export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  IsoTime: any;
  JSON: any;
  Timestamp: any;
  Upload: any;
};

/** Access type for plans and classes denoting type of sub */
export enum AccessType {
  Basic = "basic",
  Free = "free",
  Premium = "premium",
  Standard = "standard",
}

export type AccountTypeOption = {
  __typename?: "AccountTypeOption";
  /** The description of a account type option. */
  description: Scalars["String"];
  /** The label of a account type option. */
  lable: Scalars["String"];
  /** A preview GIF URL for each account type option. */
  previewGIFUrl?: Maybe<Scalars["String"]>;
  /** The slug of a account type option. */
  slug: Scalars["ID"];
};

export type Achievement = {
  __typename?: "Achievement";
  badges: Array<Badge>;
  challenge?: Maybe<Challenge>;
  createdAt: Scalars["DateTime"];
  description?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
  /** The published studio classes required to earn this achievement. Requires the user role to use. */
  requiredPublishedStudioClasses?: Maybe<Array<StudioClass>>;
  triggerType: AchievementTriggerType;
  updatedAt: Scalars["DateTime"];
};

export type AchievementCreateInput = {
  description?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  triggerType: AchievementTriggerType;
};

export type AchievementFilter = {
  name?: InputMaybe<Scalars["String"]>;
  triggerType?: InputMaybe<AchievementTriggerType>;
};

export type AchievementStudioClassInput = {
  achievementId: Scalars["String"];
  studioClassId: Scalars["String"];
};

/** The type of the trigger for the achievement */
export enum AchievementTriggerType {
  ClassCompletion = "ClassCompletion",
  ClassMinutesSpent = "ClassMinutesSpent",
  ClassTaken = "ClassTaken",
  PostComment = "PostComment",
  PostUpload = "PostUpload",
  RequiredClassCompletion = "RequiredClassCompletion",
  RequiredClassTaken = "RequiredClassTaken",
}

export type AchievementUpdateInput = {
  achievementId: Scalars["String"];
  challengeId?: InputMaybe<Scalars["String"]>;
  description?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  requiredStudioClassIds?: InputMaybe<Array<Scalars["String"]>>;
  triggerType: AchievementTriggerType;
};

export type ActionCuepoint = {
  __typename?: "ActionCuepoint";
  actionCopy: Scalars["String"];
  endsAtTime: Scalars["String"];
  endsAtTimeSec: Scalars["Int"];
  externalUrl: Scalars["String"];
  infoUrl?: Maybe<Scalars["String"]>;
  startsAtTime: Scalars["String"];
  startsAtTimeSec: Scalars["Int"];
  type: ActionCuepointType;
};

export type ActionCuepointInput = {
  actionCopy: Scalars["String"];
  endsAtTimeSec: Scalars["Int"];
  externalUrl: Scalars["String"];
  infoUrl?: InputMaybe<Scalars["String"]>;
  startsAtTimeSec: Scalars["Int"];
  type: ActionCuepointType;
};

/** Types of action cuepoints that can be added to a class */
export enum ActionCuepointType {
  ExternalMusicLink = "external_music_link",
}

export type ActivityClassCommentCreateInput = {
  body: Scalars["String"];
  classNumber?: InputMaybe<Scalars["Float"]>;
  parentCommentId?: InputMaybe<Scalars["String"]>;
  studioClassId?: InputMaybe<Scalars["String"]>;
};

export type ActivityComment = {
  __typename?: "ActivityComment";
  body: Scalars["String"];
  /** The profile of the user who created the comment. */
  commentBy: UserProfile;
  createdAt: Scalars["DateTime"];
  /** The number of times the video has been flagged. Requires the admin role to use. */
  flaggedCount: Scalars["Float"];
  id: Scalars["ID"];
  /** True if the comment was created by the requesting user. */
  isAuthoredByMe: Scalars["Boolean"];
  /** The number of reactions to this comment by type. */
  reactions: Array<ActivityReactionsCount>;
  /** A paginated list of this comment's replies. */
  replies?: Maybe<ActivityCommentConnection>;
  /** True if the requesting user has reported this comment. */
  reportedByMe: Scalars["Boolean"];
  timeSince: Scalars["String"];
  updatedAt: Scalars["DateTime"];
  user: User;
  /** The requesting user's reactions to the comment. */
  userReactions: Array<UserReactionType>;
};

export type ActivityCommentRepliesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Float"]>;
  last?: InputMaybe<Scalars["Float"]>;
};

export type ActivityCommentConnection = {
  __typename?: "ActivityCommentConnection";
  edges: Array<ActivityCommentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type ActivityCommentCreateInput = {
  body: Scalars["String"];
  contentId: Scalars["String"];
  contentType: ContentType;
  parentCommentId?: InputMaybe<Scalars["String"]>;
};

export type ActivityCommentEdge = {
  __typename?: "ActivityCommentEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: ActivityComment;
};

export type ActivityCommentUpdateInput = {
  body: Scalars["String"];
  commentId: Scalars["String"];
};

export type ActivityReaction = {
  __typename?: "ActivityReaction";
  createdAt: Scalars["DateTime"];
  id: Scalars["ID"];
  reactionType: UserReactionType;
  timeSince: Scalars["String"];
  updatedAt: Scalars["DateTime"];
  user: User;
};

export type ActivityReactionCreateInput = {
  contentId: Scalars["String"];
  contentType: ContentType;
  reactionType: UserReactionType;
};

export type ActivityReactionDeleteInput = {
  contentId: Scalars["String"];
  contentType: ContentType;
  reactionType: UserReactionType;
};

export type ActivityReactionsCount = {
  __typename?: "ActivityReactionsCount";
  reactionType: UserReactionType;
  totalCount: Scalars["Int"];
};

/** Reason why the user reported the activity */
export enum ActivityReportReason {
  Blocked = "blocked",
  Harassment = "harassment",
  Hate = "hate",
  Irrelevant = "irrelevant",
  Nudity = "nudity",
  Other = "other",
  Spam = "spam",
  Violence = "violence",
}

/** Status of the reported activity */
export enum ActivityReportStatus {
  PendingReview = "pending_review",
  Reported = "reported",
  Reviewed = "reviewed",
}

/** The result of the activity's report review */
export enum ActivityReviewDecision {
  Allow = "allow",
  Block = "block",
  None = "none",
}

/** Type of the reported activity */
export enum ActivityType {
  UserComment = "user_comment",
  UserVideo = "user_video",
}

export type Admin = {
  __typename?: "Admin";
  /** Get achievement by ID. Requires the admin role to use. */
  achievementById?: Maybe<AdminAchievement>;
  /** Get filterable achievements. Requires the admin role to use. */
  achievements: AdminAchievementConnection;
  /** Get all class levels. Requires the admin role to use. */
  allClassLevels: Array<ClassLevel>;
  /** Get all visible class styles. Requires the admin role to use. */
  allClassStyles: Array<ClassStyle>;
  /** Get all class types. Requires the admin role to use. */
  allClassTypes: Array<ClassType>;
  /** Get filterable categories. Requires the admin role to use. */
  categories: CategoryConnection;
  /** Get category by ID. Requires the admin role to use. */
  categoryById?: Maybe<ClassCategory>;
  /** Get filterable videos in a category. Requires the admin role to use. */
  categoryVideos: AdminCategoryVideoConnection;
  /** Get challenge by ID. Requires the admin role to use. */
  challengeById?: Maybe<Challenge>;
  /** Get filterable challenges. Requires the admin role to use. */
  challenges: ChallengeConnection;
  /** Get class style by ID. Requires the admin role to use. */
  classStyleById?: Maybe<ClassStyle>;
  /** Get filterable class styles. Requires the admin role to use. */
  classStyles: ClassStyleConnection;
  /** Get filterable countries. Requires the admin role to use. */
  countries: CountryConnection;
  /** Get country by ID. Requires the admin role to use. */
  countryById?: Maybe<Country>;
  /** Get instructor by ID. Requires the admin role to use. */
  instructorById?: Maybe<ClassInstructor>;
  /** Get instructor credits. Requires the admin role to use. */
  instructorCredits: Array<InstructorCredit>;
  /** Get filterable instructors. Requires the admin role to use. */
  instructors: InstructorConnection;
  /** Get plan by ID. Requires the admin role to use. */
  planById?: Maybe<Plan>;
  /** Get plan by ID. Requires the admin role to use. */
  planByProviderId?: Maybe<Plan>;
  /** Get filterable plans. Requires the admin role to use. */
  plans: PlanConnection;
  /** Get filterable playlists. Requires the admin role to use. */
  playlists: PlaylistV2Connection;
  /** All available roles Requires the admin role to use. */
  roles: Array<Role>;
  /** Get class by class number. Requires the admin role to use. */
  studioClassByClassId?: Maybe<AdminStudioClass>;
  /** Get class by ID. Requires the admin role to use. */
  studioClassById?: Maybe<AdminStudioClass>;
  /** Get filterable classes. Requires the admin role to use. */
  studioClasses: AdminStudioClassConnection;
  /** Get tags. Requires the admin role to use. */
  tagById: Tag;
  /** Get tags. Requires the admin role to use. */
  tags: TagConnection;
  /** User Requires the admin role to use. */
  user: AdminUser;
};

export type AdminAchievementByIdArgs = {
  id: Scalars["String"];
};

export type AdminAchievementsArgs = {
  filter?: InputMaybe<AchievementFilter>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type AdminCategoriesArgs = {
  filter?: InputMaybe<CategoryFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type AdminCategoryByIdArgs = {
  id: Scalars["String"];
};

export type AdminCategoryVideosArgs = {
  filter?: InputMaybe<CategoryVideoFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type AdminChallengeByIdArgs = {
  id: Scalars["String"];
};

export type AdminChallengesArgs = {
  filter?: InputMaybe<ChallengeFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type AdminClassStyleByIdArgs = {
  id: Scalars["String"];
};

export type AdminClassStylesArgs = {
  filter?: InputMaybe<ClassStyleFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type AdminCountriesArgs = {
  filter?: InputMaybe<CountryFilter>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type AdminCountryByIdArgs = {
  id: Scalars["String"];
};

export type AdminInstructorByIdArgs = {
  id: Scalars["String"];
};

export type AdminInstructorsArgs = {
  filter?: InputMaybe<InstructorFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type AdminPlanByIdArgs = {
  id: Scalars["String"];
};

export type AdminPlanByProviderIdArgs = {
  providerId: Scalars["String"];
};

export type AdminPlansArgs = {
  filter?: InputMaybe<PlanFilter>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type AdminPlaylistsArgs = {
  filter?: InputMaybe<PlaylistFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type AdminStudioClassByClassIdArgs = {
  classId: Scalars["Float"];
};

export type AdminStudioClassByIdArgs = {
  id: Scalars["String"];
};

export type AdminStudioClassesArgs = {
  filter?: InputMaybe<ClassFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type AdminTagByIdArgs = {
  id?: InputMaybe<Scalars["String"]>;
};

export type AdminTagsArgs = {
  filter?: InputMaybe<TagFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type AdminUserArgs = {
  uid: Scalars["String"];
};

export type AdminAchievement = {
  __typename?: "AdminAchievement";
  /** All required studio classes for an achievement. Requires the admin role to use. */
  allRequiredStudioClasses?: Maybe<Array<AdminStudioClass>>;
  badges: Array<Badge>;
  challenge?: Maybe<Challenge>;
  createdAt: Scalars["DateTime"];
  description?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
  /** The published studio classes required to earn this achievement. Requires the user role to use. */
  requiredPublishedStudioClasses?: Maybe<Array<StudioClass>>;
  triggerType: AchievementTriggerType;
  updatedAt: Scalars["DateTime"];
};

export type AdminAchievementConnection = {
  __typename?: "AdminAchievementConnection";
  edges: Array<AdminAchievementEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type AdminAchievementEdge = {
  __typename?: "AdminAchievementEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: AdminAchievement;
};

export type AdminCategoryVideo = {
  __typename?: "AdminCategoryVideo";
  category: ClassCategory;
  createdAt: Scalars["DateTime"];
  durationInMs?: Maybe<Scalars["String"]>;
  encodingStatus: VideoEncodingStatus;
  error?: Maybe<Scalars["String"]>;
  /** HLS playback urls for the video. Requires the user role to use. */
  hlsPlaybackUrls?: Maybe<VideoPlaybackResponse>;
  id: Scalars["ID"];
  mediaConvertJobIds?: Maybe<Array<Scalars["String"]>>;
  stepFunctionArn?: Maybe<Scalars["String"]>;
  type: VideoType;
  updatedAt: Scalars["DateTime"];
  uploadedAt?: Maybe<Scalars["DateTime"]>;
};

export type AdminCategoryVideoConnection = {
  __typename?: "AdminCategoryVideoConnection";
  edges: Array<AdminCategoryVideoEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type AdminCategoryVideoEdge = {
  __typename?: "AdminCategoryVideoEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: AdminCategoryVideo;
};

export type AdminProgram = {
  __typename?: "AdminProgram";
  averageSessionTime?: Maybe<Scalars["String"]>;
  blocks?: Maybe<Scalars["JSON"]>;
  categories?: Maybe<Array<Scalars["String"]>>;
  classes?: Maybe<Scalars["JSON"]>;
  content?: Maybe<Scalars["JSON"]>;
  hidden?: Maybe<Scalars["Boolean"]>;
  instructorName?: Maybe<Scalars["String"]>;
  instructorSlug?: Maybe<Scalars["String"]>;
  isFree?: Maybe<Scalars["Boolean"]>;
  level?: Maybe<Scalars["String"]>;
  publishDate?: Maybe<Scalars["String"]>;
  relatedClasses?: Maybe<Array<Scalars["Int"]>>;
  sections?: Maybe<Scalars["JSON"]>;
  slug: Scalars["String"];
  style?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
  totalClassesCount?: Maybe<Scalars["Int"]>;
};

export type AdminStudioClass = {
  __typename?: "AdminStudioClass";
  accessType?: Maybe<AccessType>;
  /** The action cuepoints for the class. Requires the admin role to use. */
  actionCuepoints: Array<ActionCuepoint>;
  /** The categories for this class. Requires the admin role to use. */
  categories: Array<ClassCategory>;
  classId: Scalars["Float"];
  createdAt: Scalars["DateTime"];
  externalPreviewUrl?: Maybe<Scalars["String"]>;
  /** @deprecated Use accessType */
  free: Scalars["Boolean"];
  hidden: Scalars["Boolean"];
  id: Scalars["ID"];
  instructor?: Maybe<ClassInstructor>;
  /** True if class has licensing rights to all its tracks */
  isClassFullyLicensed: Scalars["Boolean"];
  /** True if this class contains an explicit track. Requires the user role to use. */
  isExplicit: Scalars["Boolean"];
  isFamilyFriendly: Scalars["Boolean"];
  /** @deprecated Use classVideoType on video instead. */
  isSingleView: Scalars["Boolean"];
  level?: Maybe<Scalars["String"]>;
  /** The muted cuepoints for the class. Requires the admin role to use. */
  mutedCuepoints: Array<MutedCuepoint>;
  /** Currently published preview video Requires the admin role to use. */
  previewVideo?: Maybe<ClassVideo>;
  publishDate?: Maybe<Scalars["DateTime"]>;
  sections?: Maybe<Array<StudioClassSectionEntity>>;
  /** @deprecated Use isClassFullyLicensed resolver */
  shouldBeMuted: Scalars["Boolean"];
  slug: Scalars["String"];
  /** @deprecated Use StyleV2. */
  style?: Maybe<Scalars["String"]>;
  /** Requires the user role to use. */
  styleV2?: Maybe<ClassStyle>;
  tags: Array<Tag>;
  thumbnailImageId?: Maybe<Scalars["String"]>;
  /** Full thumbnail image url. Requires the user role to use. */
  thumbnailImageUrl?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
  /** The tracks in this class. Requires the admin role to use. */
  tracks: Array<StudioClassTrack>;
  type?: Maybe<Scalars["String"]>;
  updatedAt: Scalars["DateTime"];
  /** User progress for class. Requires the user role to use. */
  userProgress: UserClassProgress;
  /** Currently published video Requires the admin role to use. */
  video?: Maybe<ClassVideo>;
};

export type AdminStudioClassConnection = {
  __typename?: "AdminStudioClassConnection";
  edges: Array<AdminStudioClassEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type AdminStudioClassEdge = {
  __typename?: "AdminStudioClassEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: AdminStudioClass;
};

export type AdminUser = {
  __typename?: "AdminUser";
  /** User's PII data in JSON Requires the admin role to use. */
  PII: Scalars["String"];
};

export type AdminUserSyncRevenueCatInput = {
  /** User's Firebase UID */
  uid: Scalars["String"];
};

export type AdminUserUpdateLogin = {
  password: Scalars["String"];
  uid: Scalars["String"];
};

export type AlgoliaClassesConnection = {
  __typename?: "AlgoliaClassesConnection";
  /** The list of Steezy class edges. */
  edges: Array<ClassEdge>;
  /** Pagination metadata. */
  pageInfo: AlgoliaPageInfo;
};

export type AlgoliaInstructorsConnection = {
  __typename?: "AlgoliaInstructorsConnection";
  /** The list of Steezy instructor edges. */
  edges: Array<InstructorEdge>;
  /** Pagination metadata. */
  pageInfo: AlgoliaPageInfo;
};

export type AlgoliaPageInfo = {
  __typename?: "AlgoliaPageInfo";
  /** Boolean value describing whether the page input parameter can be incremented to fetch further results. (page < nbPages - 1) */
  hasNextPage: Scalars["Boolean"];
  /** Boolean value describing whether there are previous pages. (page !== 0) */
  hasPreviousPage: Scalars["Boolean"];
  /** The total number of hits matching the search state. */
  nbHits: Scalars["Int"];
  /** The total number of pages in the search response. */
  nbPages: Scalars["Int"];
  /** The current, zero-indexed page of responses. */
  page: Scalars["Int"];
};

export type AlgoliaProgramsConnection = {
  __typename?: "AlgoliaProgramsConnection";
  /** The list of Steezy program edges. */
  edges: Array<ProgramEdge>;
  /** Pagination metadata. */
  pageInfo: AlgoliaPageInfo;
};

export type AlgoliaSearchInput = {
  /** Filter the query with numeric, facet and/or tag filters. */
  filters?: InputMaybe<Scalars["String"]>;
  /** Set the number of hits per page. */
  hitsPerPage?: InputMaybe<Scalars["Int"]>;
  /** The name of the index to query against. */
  index: Scalars["String"];
  /** Specify the page to retrieve. */
  page?: InputMaybe<Scalars["Int"]>;
  /** The query used to search. Accepts every character, and every character entered will be used in the search. An empty query can be used to fetch all records. */
  query: Scalars["String"];
};

export type AppUpdateConfig = {
  __typename?: "AppUpdateConfig";
  isMandatory: Scalars["Boolean"];
  minimumPlatformVersion: Scalars["Float"];
  storeUrl: Scalars["String"];
  version: Scalars["String"];
};

export type ApprovePartyMemberInput = {
  isApproved: Scalars["Boolean"];
  pid: Scalars["String"];
  uid: Scalars["String"];
};

export type AssignPlanToCountryInput = {
  /** The unique identifier of the country */
  countryId?: InputMaybe<Scalars["String"]>;
  /** The ISO 3166-1 alpha-2 code of the country (e.g., 'US', 'GB') */
  countryIsoCode?: InputMaybe<Scalars["String"]>;
  /** The unique identifier of the plan to assign */
  planId?: InputMaybe<Scalars["String"]>;
  /** The provider identifier of the plan to assign */
  providerId?: InputMaybe<Scalars["String"]>;
  /** The provider name (required if providerId is provided) */
  providerName?: InputMaybe<SubscriptionProvider>;
};

export type AutocompleteValue = {
  __typename?: "AutocompleteValue";
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type Badge = {
  __typename?: "Badge";
  achievement: Achievement;
  activeImageId?: Maybe<Scalars["String"]>;
  /** The active badge image URL. */
  activeImageUrl?: Maybe<Scalars["String"]>;
  amountToEarn: Scalars["Float"];
  challenge?: Maybe<Challenge>;
  createdAt: Scalars["DateTime"];
  description?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  inactiveImageId?: Maybe<Scalars["String"]>;
  /** The inactive badge image URL. */
  inactiveImageUrl?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  updatedAt: Scalars["DateTime"];
};

/** Badge asset types */
export enum BadgeAssetType {
  Active = "active",
  Inactive = "inactive",
}

export type BadgeCreateInput = {
  achievementId: Scalars["String"];
  amountToEarn?: InputMaybe<Scalars["Int"]>;
  description?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
};

export type BadgeUpdateInput = {
  activeImageExtension?: InputMaybe<Scalars["String"]>;
  activeImageId?: InputMaybe<Scalars["String"]>;
  amountToEarn?: InputMaybe<Scalars["Int"]>;
  badgeId: Scalars["String"];
  description?: InputMaybe<Scalars["String"]>;
  inactiveImageExtension?: InputMaybe<Scalars["String"]>;
  inactiveImageId?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
};

export type BadgeWithEarnedStatus = {
  __typename?: "BadgeWithEarnedStatus";
  badge: Badge;
  isEarned: Scalars["Boolean"];
};

export type BadgeYearGroup = {
  __typename?: "BadgeYearGroup";
  userBadges: Array<UserBadge>;
  year: Scalars["Int"];
};

/** The unit of measure for the plan's billing period */
export enum BillingPeriodUnit {
  Day = "day",
  Month = "month",
  Week = "week",
  Year = "year",
}

export enum CacheControlScope {
  Private = "PRIVATE",
  Public = "PUBLIC",
}

export type CalculatedChallengeProgress = {
  __typename?: "CalculatedChallengeProgress";
  challenge: Challenge;
  isCompleted: Scalars["Boolean"];
};

/** Reasons for canceling a subscription */
export enum CancelReason {
  HardToUse = "hard_to_use",
  MissingContent = "missing_content",
  NoTime = "no_time",
  NotEnoughClasses = "not_enough_classes",
  Other = "other",
  TakingBreak = "taking_break",
  TechnicalIssues = "technical_issues",
  TooExpensive = "too_expensive",
}

export type CancelSurvey = {
  __typename?: "CancelSurvey";
  additionalFeedback?: Maybe<Scalars["String"]>;
  createdAt: Scalars["DateTime"];
  id: Scalars["ID"];
  joinAgainReason?: Maybe<Scalars["String"]>;
  otherReason?: Maybe<Scalars["String"]>;
  overallExperienceRating: Scalars["Int"];
  reason: CancelReason;
  subscription: Subscription;
  updatedAt: Scalars["DateTime"];
};

export type CancelSurveyInput = {
  additionalFeedback?: InputMaybe<Scalars["String"]>;
  joinAgainReason?: InputMaybe<Scalars["String"]>;
  otherReason?: InputMaybe<Scalars["String"]>;
  overallExperienceRating: Scalars["Int"];
  reason: CancelReason;
  subscriptionId: Scalars["String"];
};

export type Card = {
  __typename?: "Card";
  brand?: Maybe<Scalars["String"]>;
  fundingType?: Maybe<Scalars["String"]>;
  lastFour?: Maybe<Scalars["String"]>;
  object?: Maybe<Scalars["String"]>;
};

export type Category = {
  __typename?: "Category";
  description?: Maybe<Scalars["String"]>;
  isFollowing?: Maybe<Scalars["Boolean"]>;
  latestClasses: Array<Class>;
  movesClasses: Array<Class>;
  name: Scalars["String"];
  previewThumbnailUrl?: Maybe<Scalars["String"]>;
  previewVideoUrl?: Maybe<Scalars["String"]>;
  /** @deprecated Use ProgramsV2 */
  programs: Array<Program>;
  programsV2: Array<ProgramV2>;
  shortClasses: Array<Class>;
  slug: Scalars["String"];
};

/** Category asset types */
export enum CategoryAssetType {
  Thumbnail = "thumbnail",
}

export type CategoryConnection = {
  __typename?: "CategoryConnection";
  edges: Array<CategoryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type CategoryCreateInput = {
  name: Scalars["String"];
};

export type CategoryEdge = {
  __typename?: "CategoryEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: ClassCategory;
};

export enum CategoryFilter {
  IsOnboarding = "isOnboarding",
}

export type CategoryFilterInput = {
  hidden?: InputMaybe<Scalars["Boolean"]>;
  isOnboarding?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  slug?: InputMaybe<Scalars["String"]>;
};

export type CategoryTileImageUploadInput = {
  categoryId: Scalars["String"];
  svg: Scalars["String"];
};

export type CategoryTileImageUploadResponse = {
  __typename?: "CategoryTileImageUploadResponse";
  url: Scalars["String"];
};

export type CategoryUpdateInput = {
  categoryId: Scalars["String"];
  description?: InputMaybe<Scalars["String"]>;
  hidden?: InputMaybe<Scalars["Boolean"]>;
  isOnboarding?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  previewVideoId?: InputMaybe<Scalars["String"]>;
  slug?: InputMaybe<Scalars["String"]>;
  sortIndex?: InputMaybe<Scalars["Float"]>;
  thumbnailImageId?: InputMaybe<Scalars["String"]>;
};

export type CategoryVideo = {
  __typename?: "CategoryVideo";
  category: ClassCategory;
  createdAt: Scalars["DateTime"];
  durationInMs?: Maybe<Scalars["String"]>;
  encodingStatus: VideoEncodingStatus;
  error?: Maybe<Scalars["String"]>;
  /** HLS playback urls for the video. Requires the user role to use. */
  hlsPlaybackUrls?: Maybe<VideoPlaybackResponse>;
  id: Scalars["ID"];
  mediaConvertJobIds?: Maybe<Array<Scalars["String"]>>;
  stepFunctionArn?: Maybe<Scalars["String"]>;
  type: VideoType;
  updatedAt: Scalars["DateTime"];
  uploadedAt?: Maybe<Scalars["DateTime"]>;
};

export type CategoryVideoFileCreateInput = {
  categoryId: Scalars["String"];
  parts: Scalars["Float"];
};

export type CategoryVideoFilterInput = {
  categoryId?: InputMaybe<Scalars["String"]>;
  encodingStatus?: InputMaybe<VideoEncodingStatus>;
  updatedAfter?: InputMaybe<Scalars["DateTime"]>;
  updatedBefore?: InputMaybe<Scalars["DateTime"]>;
};

export type Challenge = {
  __typename?: "Challenge";
  achievement?: Maybe<Achievement>;
  badges: Array<BadgeWithEarnedStatus>;
  challengeStatus: ChallengeStatus;
  /** Comments for this challenge. */
  comments?: Maybe<ActivityCommentConnection>;
  createdAt: Scalars["DateTime"];
  description?: Maybe<Scalars["String"]>;
  displayText?: Maybe<ChallengeDisplayText>;
  endTime: Scalars["DateTime"];
  forClass?: Maybe<Class>;
  id: Scalars["ID"];
  /** True if the challenge is active. */
  isActive: Scalars["Boolean"];
  participantLeaderboard: Array<ChallengeParticipant>;
  participants: Array<ChallengeParticipant>;
  /** Number of reactions to this challenge by type. */
  reactions: Array<ActivityReactionsCount>;
  startTime: Scalars["DateTime"];
  /** The total number of published video uploads for this challenge. */
  submissionsCount: Scalars["Int"];
  thumbnailImageId?: Maybe<Scalars["String"]>;
  /** The challenge thumbnail image URL. */
  thumbnailImageUrl?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
  updatedAt: Scalars["DateTime"];
  /** User progress for this challenge. This will calculate a user's progress on the challenge when being called. */
  userProgress?: Maybe<UserProgressChallenge>;
  /** User reactions for this challenge. */
  userReactions?: Maybe<Array<UserReactionType>>;
  /** The published video uploads for this challenge. */
  videos?: Maybe<VideoUploadConnection>;
};

export type ChallengeCommentsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Float"]>;
  last?: InputMaybe<Scalars["Float"]>;
};

export type ChallengeVideosArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Float"]>;
  last?: InputMaybe<Scalars["Float"]>;
};

export type ChallengeConnection = {
  __typename?: "ChallengeConnection";
  edges: Array<ChallengeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type ChallengeCreateInput = {
  achievementId?: InputMaybe<Scalars["String"]>;
  challengeStatus: ChallengeStatus;
  classId?: InputMaybe<Scalars["String"]>;
  description?: InputMaybe<Scalars["String"]>;
  displayText?: InputMaybe<ChallengeDisplayTextInput>;
  endTime: Scalars["DateTime"];
  startTime: Scalars["DateTime"];
  title: Scalars["String"];
};

/** Challenge display text */
export type ChallengeDisplayText = {
  __typename?: "ChallengeDisplayText";
  earnedByHeader?: Maybe<Scalars["String"]>;
  goalHeader?: Maybe<Scalars["String"]>;
  subtitleHeader?: Maybe<Scalars["String"]>;
};

export type ChallengeDisplayTextInput = {
  earnedByHeader?: InputMaybe<Scalars["String"]>;
  goalHeader?: InputMaybe<Scalars["String"]>;
  subtitleHeader?: InputMaybe<Scalars["String"]>;
};

export type ChallengeEdge = {
  __typename?: "ChallengeEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: Challenge;
};

export type ChallengeFilterInput = {
  activeAfter?: InputMaybe<Scalars["DateTime"]>;
  activeBefore?: InputMaybe<Scalars["DateTime"]>;
  challengeStatus?: InputMaybe<Array<ChallengeStatus>>;
  classId?: InputMaybe<Scalars["String"]>;
};

export type ChallengeParticipant = {
  __typename?: "ChallengeParticipant";
  challenge: Challenge;
  createdAt: Scalars["DateTime"];
  id: Scalars["ID"];
  joinedAt: Scalars["DateTime"];
  progressAmount: Scalars["Float"];
  updatedAt: Scalars["DateTime"];
  user: User;
};

export type ChallengeProgressResult = {
  __typename?: "ChallengeProgressResult";
  challengesProgressed: Array<CalculatedChallengeProgress>;
  newlyEarnedBadges: Array<UserBadge>;
};

/** The challenge's status */
export enum ChallengeStatus {
  Approved = "approved",
  Deleted = "deleted",
  None = "none",
}

export type ChallengeUpdateInput = {
  achievementId?: InputMaybe<Scalars["String"]>;
  challengeId: Scalars["String"];
  challengeStatus: ChallengeStatus;
  description?: InputMaybe<Scalars["String"]>;
  displayText?: InputMaybe<ChallengeDisplayTextInput>;
  endTime: Scalars["DateTime"];
  startTime: Scalars["DateTime"];
  thumbnailImageId?: InputMaybe<Scalars["String"]>;
  title: Scalars["String"];
};

export type ChangePlanEstimate = {
  __typename?: "ChangePlanEstimate";
  changePlanType: ChangePlanType;
  invoiceEstimate?: Maybe<SubscriptionInvoiceEstimate>;
  isEndOfTerm: Scalars["Boolean"];
};

/** The type of switch that a user is making when switching plans. */
export enum ChangePlanType {
  BillingPeriod = "billing_period",
  Downgrade = "downgrade",
  None = "none",
  Upgrade = "upgrade",
}

export type CheckSubscriptionCouponInput = {
  /** The coupon code to check for. */
  couponId: Scalars["String"];
  /** The ID of the subscription to check. */
  subscriptionId: Scalars["String"];
};

export type CheckoutEstimate = {
  __typename?: "CheckoutEstimate";
  coupon?: Maybe<Coupon>;
  discountPlanPriceInCents: Scalars["Float"];
  /** Determines the monthly price of the plan, given the plan's discounted price and period unit (i.e. a $99.99 annual plan would return 833 here to represent the cost per month in cents) */
  monthlyDiscountPlanPriceInCents?: Maybe<Scalars["Float"]>;
  /** Determines the monthly savings of the plan, given the plan's discounted price and period unit. */
  monthlySavingsAfterDiscountInPercent?: Maybe<Scalars["Float"]>;
  /**
   * Determines the date value at which a user will be billed the normal plan price, assuming they apply a valid coupon
   * @deprecated No longer used for copy on checkout page.
   */
  nextNormalBillingAt?: Maybe<Scalars["Float"]>;
};

export type CheckoutEstimateInput = {
  couponId?: InputMaybe<Scalars["String"]>;
  planInfo: PlanInfoInput;
  referralCode?: InputMaybe<Scalars["String"]>;
};

export type Class = {
  __typename?: "Class";
  /** Access type to determine user access on class. */
  accessType: AccessType;
  /** The action cuepoints for the class. Requires the user role to use. */
  actionCuepoints: Array<ActionCuepoint>;
  /** True if user has access to class based on given set of criteria. */
  canUserTakeClass: Scalars["Boolean"];
  categories: Array<Scalars["String"]>;
  challenges?: Maybe<Array<Challenge>>;
  /** Returns comments for a class given a studioClassId or classNumber Requires the user role to use. */
  comments?: Maybe<ActivityCommentConnection>;
  createdAt: Scalars["DateTime"];
  description?: Maybe<Scalars["String"]>;
  duration: Scalars["String"];
  duration_in_seconds: Scalars["Int"];
  /** Returns URL to external preview video. Requires the user role to use. */
  externalPreviewUrl?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  instructor?: Maybe<Instructor>;
  /** True if class has licensing rights to all its tracks */
  isClassFullyLicensed: Scalars["Boolean"];
  /** True if this class contains an explicit track. Requires the user role to use. */
  isExplicit?: Maybe<Scalars["Boolean"]>;
  /** The published preview video for the class. Requires the user role to use. */
  isFamilyFriendly: Scalars["Boolean"];
  isFree: Scalars["Boolean"];
  /** True if this class has muted cuepoints. Requires the user role to use. */
  isPreviewVideoMuted?: Maybe<Scalars["Boolean"]>;
  isPurchased?: Maybe<Scalars["Boolean"]>;
  isSaved?: Maybe<Scalars["Boolean"]>;
  /** True if class is unlocked for the authenticated user. Only applies to FUX users. */
  isUnlocked: Scalars["Boolean"];
  level?: Maybe<Scalars["String"]>;
  /** The muted cuepoints for the class. Requires the user role to use. */
  mutedCuepoints: Array<MutedCuepoint>;
  /** The published preview video for the class. Requires the user role to use. */
  previewVideo?: Maybe<ClassVideo>;
  preview_url: Scalars["String"];
  /** Available for program classes. Represents metadata related to the program */
  programMetadata?: Maybe<ProgramClassMetadata>;
  progress?: Maybe<ClassProgress>;
  publish_date?: Maybe<Scalars["String"]>;
  /** Represents a program class reference ID when defined */
  refId?: Maybe<Scalars["String"]>;
  /** The class sections Requires the user role to use. */
  sections: Array<StudioClassSectionEntity>;
  slug: Scalars["String"];
  songs?: Maybe<Array<Maybe<Song>>>;
  /** Studio class PK Requires the user role to use. */
  studioClassId: Scalars["String"];
  style?: Maybe<Scalars["String"]>;
  thumbnail?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
  /** The tracks (with full metadata) associated with the class. Requires the user role to use. */
  tracks: Array<StudioClassTrack>;
  type: Scalars["String"];
  updatedAt: Scalars["DateTime"];
  /** The user video uploads for this class. Requires the user role to use. */
  userVideos: VideoUploadConnection;
  /** The published video for the class. Requires the user role to use. */
  video?: Maybe<ClassVideo>;
};

export type ClassCommentsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Float"]>;
  last?: InputMaybe<Scalars["Float"]>;
};

export type ClassUserVideosArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Float"]>;
  last?: InputMaybe<Scalars["Float"]>;
};

export type ClassVideoArgs = {
  hidden?: InputMaybe<Scalars["Boolean"]>;
};

export type ClassCategory = {
  __typename?: "ClassCategory";
  createdAt: Scalars["DateTime"];
  description?: Maybe<Scalars["String"]>;
  hidden: Scalars["Boolean"];
  id: Scalars["ID"];
  isOnboarding: Scalars["Boolean"];
  name?: Maybe<Scalars["String"]>;
  /** The published preview video. Requires the user role to use. */
  previewVideo?: Maybe<CategoryVideo>;
  slug: Scalars["String"];
  sortIndex: Scalars["Float"];
  thumbnailImageId?: Maybe<Scalars["String"]>;
  /** Full thumbnail image url. Requires the user role to use. */
  thumbnailImageUrl?: Maybe<Scalars["String"]>;
  updatedAt: Scalars["DateTime"];
};

export type ClassCompleteInput = {
  classId: Scalars["String"];
  /** The datetime the class was completed. UTC in ISO8601 format */
  completedDateTime: Scalars["String"];
  context?: InputMaybe<Context>;
};

export type ClassEdge = {
  __typename?: "ClassEdge";
  /** The class data node. */
  node: Class;
};

export type ClassFilterInput = {
  accessType?: InputMaybe<AccessType>;
  categoryId?: InputMaybe<Scalars["String"]>;
  classId?: InputMaybe<Scalars["String"]>;
  excludeIds?: InputMaybe<Array<Scalars["String"]>>;
  free?: InputMaybe<Scalars["Boolean"]>;
  hidden?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["String"]>;
  instructor?: InputMaybe<Scalars["String"]>;
  instructorName?: InputMaybe<Scalars["String"]>;
  level?: InputMaybe<Scalars["String"]>;
  slug?: InputMaybe<Scalars["String"]>;
  style?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  trackArtist?: InputMaybe<Scalars["String"]>;
  trackId?: InputMaybe<Scalars["String"]>;
  trackLabel?: InputMaybe<Scalars["String"]>;
  trackTitle?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
};

export type ClassIdentifier = {
  id: Scalars["String"];
  refId?: InputMaybe<Scalars["String"]>;
};

export type ClassInstructor = {
  __typename?: "ClassInstructor";
  avatarImageId?: Maybe<Scalars["String"]>;
  /** The full avatar image url. Requires the user role to use. */
  avatarImageUrl?: Maybe<Scalars["String"]>;
  bio?: Maybe<Scalars["String"]>;
  createdAt: Scalars["DateTime"];
  credits?: Maybe<Array<Scalars["String"]>>;
  facebook?: Maybe<Scalars["String"]>;
  /** Featured class for an instructor. Requires the user role to use. */
  featuredClass?: Maybe<StudioClass>;
  hidden: Scalars["Boolean"];
  id: Scalars["ID"];
  instagram?: Maybe<Scalars["String"]>;
  location?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  profileImageId?: Maybe<Scalars["String"]>;
  /** The full profile image url. Requires the user role to use. */
  profileImageUrl?: Maybe<Scalars["String"]>;
  slug: Scalars["String"];
  /** Studio classes taught by this instructor. Requires the user role to use. */
  studioClasses: StudioClassConnection;
  tiktok?: Maybe<Scalars["String"]>;
  twitter?: Maybe<Scalars["String"]>;
  updatedAt: Scalars["DateTime"];
  user?: Maybe<User>;
  /** The user profile associated with this instructor. Requires the user role to use. */
  userProfile?: Maybe<UserProfile>;
  youtube?: Maybe<Scalars["String"]>;
};

export type ClassInstructorStudioClassesArgs = {
  filter?: InputMaybe<ClassFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type ClassLevel = {
  __typename?: "ClassLevel";
  name: Scalars["String"];
};

export type ClassOrProgram = Class | Program;

export type ClassOrProgramV2 = Class | ProgramV2;

export type ClassProgramV2Edge = {
  __typename?: "ClassProgramV2Edge";
  /** The pointer reference to where the edge is in respect to the list. */
  cursor: Scalars["String"];
  /** The saved or history data node. A union type that can be either a Class or ProgramV2 type. */
  node: ClassOrProgramV2;
};

export type ClassProgress = {
  __typename?: "ClassProgress";
  /** The date the class was first completed by reaching the end of the video */
  completed?: Maybe<Scalars["String"]>;
  /** If the class is associated with a program, this progress represents the progress of the class within the context of the program */
  programClassProgress?: Maybe<Array<ProgramClassProgress>>;
  /** The date the class was first started */
  started?: Maybe<Scalars["String"]>;
  /** Timestamp object representing where the user is in the playback by hour, minute, and seconds */
  time?: Maybe<Time>;
};

export type ClassProgressInput = {
  classId: Scalars["String"];
  context?: InputMaybe<Context>;
  /** A datetime string of when the user was progressing in the class. ISO8601 UTC time */
  playedDate?: InputMaybe<Scalars["String"]>;
  playedFragments?: InputMaybe<Array<PlayedFragment>>;
  /**
   * The exact seconds a user has watched since the last invocation of the updateClassProgress mutation. For example,
   * if a user watched each second of a video between 20 and 25 seconds and rewinded it back to 22 seconds and continued
   * to watch until the 30 second timestamp and then fired the updateClassProgress call, a client would send a request
   * with the following array [20, 21, 22, 23, 24, 25, 22, 23, 24, 25, 26, 27, 28, 29, 30]. Duplicate seconds are valid.
   * The array can be reset between requests.
   */
  playedSeconds?: InputMaybe<Array<Scalars["Int"]>>;
  /**
   * The amount of seconds that has elapsed when the user started watching the class and since the last invocation of
   * the updateClassProgress mutation. SessionSeconds should be a timer incremented locally in-memory every second
   * the video is playing and reset back to 0 after each successful request to the updateClassProgress mutation.
   * SessionSeconds only increments when the video is playing. It should not increase when the video is paused.
   * It should continue to increment when the video is buffering or experiencing any latency issues.
   */
  sessionSeconds: Scalars["Int"];
  /**
   * The current second the user is on for the class video i.e. if a user is at a timestamp of 01:05:32
   * (1 hour, 5 minutes and 32 seconds) when the updateClassProgress request is made the client should send
   * (1 * 3600 seconds) + (5 * 60 seconds) + 32 seconds = 3932 for this field.
   */
  timestampSeconds: Scalars["Int"];
};

export type ClassSessionInput = {
  classId: Scalars["String"];
  context?: InputMaybe<Context>;
  /** The total amount of seconds that has elapsed when the user started watching the class INCLUDING pauses and since the last invocation of the updateClassSession mutation */
  sessionSeconds: Scalars["Int"];
};

export type ClassStartInput = {
  classId: Scalars["String"];
  context?: InputMaybe<Context>;
  /** The datetime the class was started. UTC in ISO8601 format */
  startedDateTime: Scalars["String"];
};

export type ClassStyle = {
  __typename?: "ClassStyle";
  /** Number of classes currently using this style. Requires the admin role to use. */
  classCount: Scalars["Int"];
  createdAt: Scalars["DateTime"];
  hidden: Scalars["Boolean"];
  id: Scalars["ID"];
  name: Scalars["String"];
  slug: Scalars["String"];
  sortIndex: Scalars["Float"];
  updatedAt: Scalars["DateTime"];
};

export type ClassStyleConnection = {
  __typename?: "ClassStyleConnection";
  edges: Array<ClassStyleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type ClassStyleCreateInput = {
  name: Scalars["String"];
};

export type ClassStyleEdge = {
  __typename?: "ClassStyleEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: ClassStyle;
};

export type ClassStyleFilterInput = {
  hidden?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
};

export type ClassStyleUpdateInput = {
  classStyleId: Scalars["String"];
  hidden?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  sortIndex?: InputMaybe<Scalars["Float"]>;
};

export type ClassTrackInput = {
  classId: Scalars["String"];
  isrc: Scalars["String"];
  startsAt: Scalars["Int"];
};

export type ClassType = {
  __typename?: "ClassType";
  name: Scalars["String"];
};

export type ClassUnlockInput = {
  classId: Scalars["String"];
};

export type ClassVideo = {
  __typename?: "ClassVideo";
  classVideoType: ClassVideoType;
  createdAt: Scalars["DateTime"];
  downloadSource?: Maybe<Scalars["String"]>;
  /**
   * DRM DASH playback urls for the video.
   * @deprecated DRM support ending. Use hlsPlaybackUrls instead.
   */
  drmDashPlaybackUrls?: Maybe<VideoPlaybackResponse>;
  /**
   * DRM HLS playback urls for the video.
   * @deprecated DRM support ending. Use hlsPlaybackUrls instead.
   */
  drmHlsPlaybackUrls?: Maybe<VideoPlaybackResponse>;
  durationInMs?: Maybe<Scalars["String"]>;
  encodingStatus: VideoEncodingStatus;
  error?: Maybe<Scalars["String"]>;
  /** HLS playback urls for the video. */
  hlsPlaybackUrls?: Maybe<VideoPlaybackResponse>;
  id: Scalars["ID"];
  mediaConvertJobIds?: Maybe<Array<Scalars["String"]>>;
  stepFunctionArn?: Maybe<Scalars["String"]>;
  studioClass: StudioClass;
  type: VideoType;
  updatedAt: Scalars["DateTime"];
  uploadedAt?: Maybe<Scalars["DateTime"]>;
};

export type ClassVideoConnection = {
  __typename?: "ClassVideoConnection";
  edges: Array<ClassVideoEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type ClassVideoEdge = {
  __typename?: "ClassVideoEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: ClassVideo;
};

export type ClassVideoFileCreateInput = {
  classId: Scalars["String"];
  classVideoType: ClassVideoType;
  parts: Scalars["Float"];
};

export type ClassVideoFilterInput = {
  classId?: InputMaybe<Scalars["Float"]>;
  encodingStatus?: InputMaybe<VideoEncodingStatus>;
  encodingStatuses?: InputMaybe<Array<VideoEncodingStatus>>;
  updatedAfter?: InputMaybe<Scalars["DateTime"]>;
  updatedBefore?: InputMaybe<Scalars["DateTime"]>;
};

/** The type of video for the class */
export enum ClassVideoType {
  FrontBackView = "front_back_view",
  Preview = "preview",
  SingleView = "single_view",
}

export type ClassesTakenPerDay = {
  __typename?: "ClassesTakenPerDay";
  count: Scalars["Int"];
  date: Scalars["String"];
};

export type CollectPaymentInput = {
  gateway: GatewayInput;
  invoiceId: Scalars["String"];
  type: PaymentMethodType;
};

export type Config = {
  __typename?: "Config";
  appUpdateConfig: AppUpdateConfig;
  featureFlags: Array<FeatureFlag>;
  versionReviewConfig: VersionReviewConfig;
};

export type ConfigAppUpdateConfigArgs = {
  platform: Scalars["String"];
};

export type ConnectionArgs = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars["String"]>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars["String"]>;
  /** Paginate first */
  first?: InputMaybe<Scalars["Float"]>;
  /** Paginate last */
  last?: InputMaybe<Scalars["Float"]>;
};

/** The base type for namespacing content-related queries */
export type Content = {
  __typename?: "Content";
  featuredModal?: Maybe<FeaturedModalContent>;
  freeUserExperience?: Maybe<FreeUserExperienceContent>;
};

/** The base type for namespacing content-related queries */
export type ContentFeaturedModalArgs = {
  input: FeaturedModalSlugInput;
};

/** The module or scope the content is associated with e.g. challenges, modals, etc. */
export enum ContentModule {
  Challenges = "challenges",
  ForYou = "for_you",
  Modals = "modals",
}

/** Type of the content */
export enum ContentType {
  Classes = "CLASSES",
  Programs = "PROGRAMS",
  Challenge = "challenge",
  ClassVideo = "class_video",
  UserComment = "user_comment",
  UserVideo = "user_video",
}

/** The context the current class is being played in. This helps determine what progress nodes to update when classes have many-to-many relationships. */
export type Context = {
  partyId?: InputMaybe<Scalars["String"]>;
  /** The playlistDate is a date string formatted as YYYY-MM-DD. The playlistDate refers to the playlist associated with the date of a user's schedule. */
  playlistDate?: InputMaybe<Scalars["String"]>;
  /** The playlistId is an ID for PlaylistV2. */
  playlistId?: InputMaybe<Scalars["String"]>;
  /** The program reference ID. This helps reference what block and section the program class is associated with. */
  programClassRefId?: InputMaybe<Scalars["String"]>;
  /** The schedulePlaylistId is an ID for the SchedulePlaylist. */
  schedulePlaylistId?: InputMaybe<Scalars["String"]>;
};

export type Country = {
  __typename?: "Country";
  createdAt: Scalars["DateTime"];
  id: Scalars["ID"];
  /** ISO 3166-1 alpha-2 two-letter country code (e.g. 'US', 'GB', 'DE') */
  isoCode: Scalars["String"];
  name: Scalars["String"];
  plans: Array<Plan>;
  updatedAt: Scalars["DateTime"];
};

export type CountryConnection = {
  __typename?: "CountryConnection";
  edges: Array<CountryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type CountryEdge = {
  __typename?: "CountryEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: Country;
};

export type CountryFilter = {
  isoCode?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
};

export type Coupon = {
  __typename?: "Coupon";
  createdAt: Scalars["DateTime"];
  discountAmount?: Maybe<Scalars["Float"]>;
  discountDuration?: Maybe<Scalars["Float"]>;
  discountPercentage?: Maybe<Scalars["Float"]>;
  discountType: DiscountType;
  durationType: DurationType;
  id: Scalars["ID"];
  name: Scalars["String"];
  planConstraint: PlanConstraint;
  planIds?: Maybe<Array<Scalars["String"]>>;
  provider: ProviderInfo;
  status: CouponStatus;
  updatedAt: Scalars["DateTime"];
  validTill?: Maybe<Scalars["DateTime"]>;
};

/** The coupon's current status */
export enum CouponStatus {
  Active = "active",
  Archived = "archived",
  Expired = "expired",
}

export type CreateAssetUploadResponse = {
  __typename?: "CreateAssetUploadResponse";
  id: Scalars["ID"];
  signedUrl: Scalars["String"];
};

export type CreateCountryInput = {
  isoCode: Scalars["String"];
  name: Scalars["String"];
};

export type CreatePartyInput = {
  classId: Scalars["Int"];
  /** A boolean flag determining whether or not the party was started from a free class */
  isFreeClass?: InputMaybe<Scalars["Boolean"]>;
};

export type CreatePartyOutput = {
  __typename?: "CreatePartyOutput";
  accessToken: Scalars["String"];
  classId: Scalars["Int"];
  expiresAt: Scalars["String"];
  id: Scalars["String"];
  sessionId: Scalars["String"];
  status: Scalars["String"];
};

export type CreateRecommendedSchedulePlaylistInput = {
  /** Date for the requested playlist day. Format is YYYY-MM-DD. */
  date: Scalars["String"];
};

export type CreateSchedulePlaylistInput = {
  classIds: Array<Scalars["String"]>;
  /** Date for the requested playlist day. Format is YYYY-MM-DD. */
  date: Scalars["String"];
};

export type CreateSchedulePlaylistInputV2 = {
  classIds: Array<ClassIdentifier>;
  /** Date for the requested playlist day. Format is YYYY-MM-DD. */
  date: Scalars["String"];
};

export type DailyStreak = {
  __typename?: "DailyStreak";
  achievedDailyStreakDate: Scalars["String"];
  date: Scalars["String"];
  id: Scalars["String"];
};

export type DancePreferences = {
  __typename?: "DancePreferences";
  /** A list a user's followed categories. */
  categories: Array<Category>;
  /** A user's duration preference. */
  duration?: Maybe<DurationOption>;
  /** A user's level preference. */
  level?: Maybe<LevelOption>;
  /** A user's reason preference. */
  reason?: Maybe<ReasonOption>;
};

/** The type of discount */
export enum DiscountType {
  FixedAmount = "fixed_amount",
  Percentage = "percentage",
}

/** An invoice's dunning status */
export enum DunningStatus {
  Exhausted = "exhausted",
  InProgress = "in_progress",
  Stopped = "stopped",
  Success = "success",
}

export type DurationOption = {
  __typename?: "DurationOption";
  /** The description of a duration option. */
  description: Scalars["String"];
  /** The end time of a duration option. */
  end: Scalars["Int"];
  /** The name of a duration option. */
  name: Scalars["String"];
  /** The slug of a duration option. */
  slug: Scalars["ID"];
  /** The start time of a duration option. */
  start: Scalars["Int"];
};

/** Specifies the time duration this coupon is applicable */
export enum DurationType {
  Forever = "forever",
  LimitedPeriod = "limited_period",
  OneTime = "one_time",
}

/** The type of the entity that earned the badge */
export enum EarnedByType {
  Challenges = "Challenges",
  Classes = "Classes",
  Events = "Events",
  Playlists = "Playlists",
  Programs = "Programs",
  UserComments = "UserComments",
  UserVideos = "UserVideos",
}

export type ExpressCheckoutPaymentIntentGenerateInput = {
  amountInCents: Scalars["Float"];
};

/** The content to render a FreeUserExperience first-launch modal */
export type FuxFirstLaunchModal = {
  __typename?: "FUXFirstLaunchModal";
  /** The body text of the modal */
  body?: Maybe<Scalars["String"]>;
  /** The call to action button text of the modal */
  callToAction?: Maybe<Scalars["String"]>;
  /** The header text of the modal */
  header?: Maybe<Scalars["String"]>;
  headerVariant?: Maybe<Scalars["JSON"]>;
  /** @deprecated Use programV2 */
  program?: Maybe<Program>;
  /** The program V2 to render for the modal */
  programV2?: Maybe<ProgramV2>;
  /** The subheader text of the modal */
  subheader?: Maybe<Scalars["String"]>;
};

export type FamilyGoalOption = {
  __typename?: "FamilyGoalOption";
  /** The description of a family goal option. */
  description: Scalars["String"];
  /** The label of a family goal option. */
  label: Scalars["String"];
  /** A preview GIF URL for each family goal option. */
  previewGIFUrl?: Maybe<Scalars["String"]>;
  /** The slug of a family goal option. */
  slug: Scalars["ID"];
};

export type FeatureFlag = {
  __typename?: "FeatureFlag";
  enabled: Scalars["Boolean"];
  name: Scalars["String"];
};

export type FeaturedContent = {
  __typename?: "FeaturedContent";
  content: FeaturedContentUnion;
  sortIndex: Scalars["Int"];
};

export type FeaturedContentUnion = Class;

export type FeaturedModalContent = {
  __typename?: "FeaturedModalContent";
  /** Body text for featured modal */
  body?: Maybe<Scalars["String"]>;
  /** Text on button of featured modal */
  ctaText?: Maybe<Scalars["String"]>;
  /** The date the user observed the featured modal */
  hasSeen: Scalars["Boolean"];
  /** Header text for featured modal */
  header?: Maybe<Scalars["String"]>;
  /** Program data for featured modal */
  program?: Maybe<ProgramV2>;
  /** The slug referencing this featured modal */
  slug: Scalars["String"];
  /** Subheader text for featured modal */
  subHeader?: Maybe<Scalars["String"]>;
};

export type FeaturedModalSlugInput = {
  /** The slug of the featured modal */
  slug: Scalars["ID"];
};

export type FeaturedPlaylist = {
  __typename?: "FeaturedPlaylist";
  createdAt: Scalars["DateTime"];
  displayOrder: Scalars["Int"];
  id: Scalars["ID"];
  playlist: PlaylistV2;
  updatedAt: Scalars["DateTime"];
};

export type FeaturedStudioClass = {
  __typename?: "FeaturedStudioClass";
  createdAt: Scalars["DateTime"];
  displayOrder: Scalars["Int"];
  id: Scalars["ID"];
  studioClass: StudioClass;
  updatedAt: Scalars["DateTime"];
};

export type FlaggedActivity = {
  __typename?: "FlaggedActivity";
  activityId: Scalars["String"];
  activityType: ActivityType;
  activityUserId?: Maybe<Scalars["String"]>;
  /** Get video or comment associated with the flagged activity. Requires the admin role to use. */
  content?: Maybe<FlaggedActivityContent>;
  createdAt: Scalars["DateTime"];
  description?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  reportReason: ActivityReportReason;
  reportStatus: ActivityReportStatus;
  reviewDecision: ActivityReviewDecision;
  reviewNotes?: Maybe<Scalars["String"]>;
  reviewedBy?: Maybe<User>;
  updatedAt: Scalars["DateTime"];
};

export type FlaggedActivityConnection = {
  __typename?: "FlaggedActivityConnection";
  edges: Array<FlaggedActivityEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type FlaggedActivityContent = ActivityComment | VideoUpload;

export type FlaggedActivityCreateInput = {
  activityId: Scalars["String"];
  activityType: ActivityType;
  description?: InputMaybe<Scalars["String"]>;
  reportReason: ActivityReportReason;
};

export type FlaggedActivityEdge = {
  __typename?: "FlaggedActivityEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: FlaggedActivity;
};

export type FlaggedActivityFilterInput = {
  activityId?: InputMaybe<Scalars["String"]>;
  activityType?: InputMaybe<ActivityType>;
  activityUserId?: InputMaybe<Scalars["String"]>;
  reportReason?: InputMaybe<ActivityReportReason>;
  reportStatus?: InputMaybe<ActivityReportStatus>;
  reportedAfter?: InputMaybe<Scalars["DateTime"]>;
  reportedBefore?: InputMaybe<Scalars["DateTime"]>;
};

export type FlaggedActivityReviewInput = {
  ejectUser?: InputMaybe<Scalars["Boolean"]>;
  reportId: Scalars["String"];
  reviewDecision: ActivityReviewDecision;
  reviewNotes?: InputMaybe<Scalars["String"]>;
};

export type FollowCategoriesInput = {
  categories: Array<FollowingInput>;
  /** String value describing where the user invoked the mutation */
  fromModule?: InputMaybe<Scalars["String"]>;
};

export type FollowCategoryInput = {
  /** String value describing where the user invoked the mutation */
  fromModule?: InputMaybe<Scalars["String"]>;
  /** Boolean value describing whether the user is following (true) or unfollowing (false) the category. */
  isFollowing: Scalars["Boolean"];
  /** The category slug. */
  slug: Scalars["ID"];
};

export type FollowCategoryOutput = {
  __typename?: "FollowCategoryOutput";
  /** A boolean value describing if the user has followed (true) or unfollowed (false). */
  isFollowing: Scalars["Boolean"];
  /** The slug of the category. */
  slug: Scalars["ID"];
};

export type FollowClassInput = {
  /** String value describing where the user invoked the mutation. */
  fromModule?: InputMaybe<Scalars["String"]>;
  /** The class ID. */
  id: Scalars["ID"];
  /** Boolean value describing whether the user is following (true) or unfollowing (false) the class. */
  isFollowing: Scalars["Boolean"];
};

export type FollowClassOutput = {
  __typename?: "FollowClassOutput";
  /** The class ID (Int/String are both applicable) being followed */
  id: Scalars["ID"];
  /** A boolean value describing if the user has followed (true) or unfollowed (false). */
  isFollowing: Scalars["Boolean"];
};

export type FollowInput = {
  /** The identifier of what the user is trying to follow. For example, this could be a class ID (Int/String are both applicable) or an instructor slug (String). */
  id: Scalars["ID"];
  /** A boolean value describing if the user is following (true) or unfollowing (false). */
  isFollowing: Scalars["Boolean"];
};

export type FollowInstructorInput = {
  /** String value describing where the user invoked the mutation. */
  fromModule?: InputMaybe<Scalars["String"]>;
  /** Boolean value describing whether the user is following (true) or unfollowing (false) the instructor. */
  isFollowing: Scalars["Boolean"];
  /** The instructor slug. */
  slug: Scalars["ID"];
};

export type FollowInstructorOutput = {
  __typename?: "FollowInstructorOutput";
  /** A boolean value describing if the user has followed (true) or unfollowed (false). */
  isFollowing: Scalars["Boolean"];
  /** The slug of an instructor */
  slug: Scalars["ID"];
};

export type FollowingInput = {
  isFollowing: Scalars["Boolean"];
  slug: Scalars["ID"];
};

/** The base type for namespacing FreeUserExperience-related content */
export type FreeUserExperienceContent = {
  __typename?: "FreeUserExperienceContent";
  firstLaunchModal?: Maybe<FuxFirstLaunchModal>;
};

/** The base type for namespacing FreeUserExperience-related content */
export type FreeUserExperienceContentFirstLaunchModalArgs = {
  programSlug: Scalars["String"];
};

export type GatewayInput = {
  provider: GatewayProvider;
  token: Scalars["String"];
};

export enum GatewayProvider {
  Braintree = "braintree",
  Stripe = "stripe",
}

export type GetCalendarDataInput = {
  endDate?: InputMaybe<Scalars["String"]>;
  startDate?: InputMaybe<Scalars["String"]>;
};

export type GetCalendarDataOutput = {
  __typename?: "GetCalendarDataOutput";
  dailyStreaks?: Maybe<Array<Maybe<DailyStreak>>>;
  userCreatedPlaylists?: Maybe<Array<Maybe<Playlist>>>;
  weeklyStreakCount?: Maybe<Scalars["Int"]>;
  weeklyStreakGoal: Scalars["Int"];
};

export type GetCategoriesInput = {
  /** Determines which categories to return; if null, return all; if >=1 given, find categories that match at least 1 filter. */
  filters?: InputMaybe<Array<CategoryFilter>>;
  /** String value of goal provided during onboarding for G17 experiment, will return categories in certain order depending on goal */
  goal?: InputMaybe<GoalType>;
  /** A list of category slugs. If no slugs are provided then all of the categories will be returned. */
  slugs: Array<Scalars["ID"]>;
};

export type GetClassInput = {
  /** The class ID */
  id: Scalars["String"];
  /** The program class reference ID */
  programClassRefId?: InputMaybe<Scalars["String"]>;
};

export type GetClassResponse = {
  __typename?: "GetClassResponse";
  current: Class;
  nextProgramClass?: Maybe<Class>;
};

export type GetClassesConnection = {
  __typename?: "GetClassesConnection";
  /** The list of matched classes. */
  classes: Array<Class>;
  /** Pagination metadata. */
  pageInfo: PaginationInfo;
};

export type GetClassesInput = {
  /** If set to true, all returned classes must be free. */
  freeOnly?: InputMaybe<Scalars["Boolean"]>;
  /** Defines the desired pagination state for the results. */
  pagination: PaginationBody;
  /** Controls the way results are sorted. Default value for 'orderBy' is 'publish_date' Default value for 'orderDirection' is 'desc'. */
  sort?: InputMaybe<SortBody>;
};

export type GetInProgressProgramsInput = {
  /** The pointer reference to where in the list the pagination should offset from. */
  after?: InputMaybe<Scalars["String"]>;
  /** The number of items to offset based from the provided 'after' cursor or the start of the paginated list. */
  first?: InputMaybe<Scalars["Int"]>;
  /** The slug of the default program if no in progress programs exist */
  slug: Scalars["ID"];
};

export type GetInstructorInput = {
  /** A slug identifier for an instructor. */
  slug: Scalars["ID"];
};

export type GetPaginatedInput = {
  /** The pointer reference to where in the list the pagination should offset from. */
  after?: InputMaybe<Scalars["String"]>;
  /** Enumerator describing what content to fetch. Can be CLASSES or PROGRAMS */
  contentType?: InputMaybe<ContentType>;
  /** The number of items to offset based from the provided 'after' cursor or the start of the paginated list. */
  first?: InputMaybe<Scalars["Int"]>;
};

export type GetProgramV2WithRefInput = {
  /** The program class reference ID */
  classRefId: Scalars["String"];
};

export type GetProgramsConnection = {
  __typename?: "GetProgramsConnection";
  /** Pagination metadata. */
  pageInfo: PaginationInfo;
  /** The list of matched programs. */
  programs: Array<Program>;
};

export type GetProgramsHistoryInput = {
  /** The pointer reference to where in the list the pagination should offset from. */
  after?: InputMaybe<Scalars["String"]>;
  /** The number of items to offset based from the provided 'after' cursor or the start of the paginated list. */
  first?: InputMaybe<Scalars["Int"]>;
};

export type GetProgramsInput = {
  /** If set to true, all returned programs must be free, and all their associated class data will only be classes accessible to free users. */
  freeOnly?: InputMaybe<Scalars["Boolean"]>;
  /** Defines the desired pagination state for the results. */
  pagination: PaginationBody;
  /** Controls the way results are sorted. Default value for 'orderBy' is 'publish_date'. Default value for 'orderDirection' is 'desc'. */
  sort?: InputMaybe<SortBody>;
};

export enum GoalType {
  Choreo = "CHOREO",
  Fitness = "FITNESS",
  Public = "PUBLIC",
  Style = "STYLE",
}

export type HistoryV3Input = {
  /** Defines the desired pagination state for the results. */
  pagination?: InputMaybe<GetPaginatedInput>;
  /** Controls the way results are sorted. Default value for 'orderBy' is 'publishDate'. Default value for 'orderDirection' is 'desc'. */
  sort?: InputMaybe<SortBodyV2>;
};

export type HlsSources = {
  __typename?: "HlsSources";
  back_view?: Maybe<VideoUrls>;
  both_views?: Maybe<VideoUrls>;
  front_view?: Maybe<VideoUrls>;
};

export type InProgressProgramData = {
  __typename?: "InProgressProgramData";
  /** Pagination connection */
  connection?: Maybe<InProgressProgramsConnection>;
  /** Signifies if user has programs in progress */
  hasProgress?: Maybe<Scalars["Boolean"]>;
};

export type InProgressProgramsConnection = {
  __typename?: "InProgressProgramsConnection";
  /** The list of Steezy in progress program data edges. */
  edges: Array<ProgramV2Edge>;
  /** Pagination metadata. */
  pageInfo: PageInfo;
};

export type Instructor = {
  __typename?: "Instructor";
  /** The biography description for the instructor. */
  bio?: Maybe<Scalars["String"]>;
  /** A list of classes published by the instructor in order of publish date. */
  classes?: Maybe<Array<Class>>;
  /** Instructor related content */
  content?: Maybe<InstructorContent>;
  /** A comma separated list of teams or organizations the instructor was apart of. */
  credits?: Maybe<Scalars["String"]>;
  /** A boolean value describing whether the current authenticated user is following (true) or not following (false) the instructor. */
  isFollowing?: Maybe<Scalars["Boolean"]>;
  /** The city and country the instructor currently resides. */
  location?: Maybe<Scalars["String"]>;
  /** The full name of the instructor. */
  name: Scalars["String"];
  /**
   * A list of programs published by the instructor in order of publish date.
   * @deprecated Use programsV2
   */
  programs?: Maybe<Array<Program>>;
  /** A list of programsV2 published by the instructor in order of publish date. */
  programsV2?: Maybe<Array<ProgramV2>>;
  /** The slug of the instructor. */
  slug: Scalars["String"];
  /** A list of social media handles for the instructor. */
  socialMediaHandles?: Maybe<Array<SocialMediaHandle>>;
  /** A list of styles associated with the instructor based on published classes. */
  styles?: Maybe<Array<Style>>;
};

/** Instructor asset types */
export enum InstructorAssetType {
  Avatar = "avatar",
  Profile = "profile",
}

export type InstructorAssets = {
  __typename?: "InstructorAssets";
  /** The instructor avatar profile URL */
  avatarURL?: Maybe<Scalars["String"]>;
  /** The instructor landscape profile URL */
  landscapeURL?: Maybe<Scalars["String"]>;
  /** The instructor portrait profile URL */
  portraitURL?: Maybe<Scalars["String"]>;
};

export type InstructorConnection = {
  __typename?: "InstructorConnection";
  edges: Array<InstructorEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type InstructorContent = {
  __typename?: "InstructorContent";
  /** Media assets for the instructor */
  assets?: Maybe<InstructorAssets>;
};

export type InstructorCreateInput = {
  name: Scalars["String"];
};

export type InstructorCredit = {
  __typename?: "InstructorCredit";
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type InstructorEdge = {
  __typename?: "InstructorEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: ClassInstructor;
};

export type InstructorFilterInput = {
  hidden?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  slug?: InputMaybe<Scalars["String"]>;
};

export type InstructorUpdateInput = {
  avatarImageId?: InputMaybe<Scalars["String"]>;
  bio?: InputMaybe<Scalars["String"]>;
  credits?: InputMaybe<Array<Scalars["String"]>>;
  facebook?: InputMaybe<Scalars["String"]>;
  featuredClassId?: InputMaybe<Scalars["Float"]>;
  hidden?: InputMaybe<Scalars["Boolean"]>;
  instagram?: InputMaybe<Scalars["String"]>;
  instructorId: Scalars["String"];
  location?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  profileImageId?: InputMaybe<Scalars["String"]>;
  slug?: InputMaybe<Scalars["String"]>;
  tiktok?: InputMaybe<Scalars["String"]>;
  twitter?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["ID"]>;
  youtube?: InputMaybe<Scalars["String"]>;
};

export type Invite = {
  __typename?: "Invite";
  /** The number of class unlocks granted to the advocate after a successful conversion. */
  advocateClassUnlocksEarned?: Maybe<Scalars["Int"]>;
  /** The USD credits granted to the advocate after a successful conversion. */
  advocateCreditCentsEarned?: Maybe<Scalars["Int"]>;
  /** The time at which the recipient subscribed (trial or active subscription). If the recipient has not converted, the value will be `null`. */
  convertedAt?: Maybe<Scalars["IsoTime"]>;
  createdAt: Scalars["DateTime"];
  id: Scalars["ID"];
  /** The time at which the recipient registered with STEEZY through web as a valid referral. This is different from the time of conversion (see `convertedAt`). */
  joinedAt: Scalars["IsoTime"];
  /** The number of class unlocks granted to the recipient after a successful conversion. */
  recipientClassUnlocksEarned?: Maybe<Scalars["Int"]>;
  /** The USD credits granted to the recipient after a successful conversion. */
  recipientCreditCentsEarned?: Maybe<Scalars["Int"]>;
  /** The time at which the advocate's referral was rewarded. If the advocate has not been rewarded, the value will be `null`. */
  rewardedAt?: Maybe<Scalars["IsoTime"]>;
  updatedAt: Scalars["DateTime"];
};

export type Invoice = {
  __typename?: "Invoice";
  amountDue: Scalars["Float"];
  createdAt: Scalars["DateTime"];
  dueDate?: Maybe<Scalars["Float"]>;
  dunningAttemptsCount: Scalars["Float"];
  dunningStatus?: Maybe<DunningStatus>;
  id: Scalars["ID"];
  nextRetryAt?: Maybe<Scalars["Float"]>;
  status: InvoiceStatus;
  subscription?: Maybe<Subscription>;
  updatedAt: Scalars["DateTime"];
  user?: Maybe<User>;
};

/** The invoice's current status */
export enum InvoiceStatus {
  NotPaid = "not_paid",
  Paid = "paid",
  PaymentDue = "payment_due",
  Pending = "pending",
  Posted = "posted",
  Voided = "voided",
}

export type IpInfoInput = {
  countryCode?: InputMaybe<Scalars["String"]>;
  countryName?: InputMaybe<Scalars["String"]>;
  regionName?: InputMaybe<Scalars["String"]>;
};

export type JoinPartyOutput = {
  __typename?: "JoinPartyOutput";
  sessionId: Scalars["String"];
};

export type LeavePartyOutput = {
  __typename?: "LeavePartyOutput";
  classId: Scalars["Int"];
  id: Scalars["String"];
};

export type LevelOption = {
  __typename?: "LevelOption";
  /** The description of a dance level option. */
  description: Scalars["String"];
  /** The name of a dance level option. */
  name: Scalars["String"];
  /** A preview GIF URL for each level option. */
  previewGIFUrl?: Maybe<Scalars["String"]>;
  /** The slug of a dance level option. */
  slug: Scalars["ID"];
};

export type ModifyPlaylistInput = {
  classIds: Array<Scalars["String"]>;
  fromModule?: InputMaybe<Scalars["String"]>;
  id: Scalars["String"];
};

export type ModifyPlaylistInputV2 = {
  classIds: Array<ClassIdentifier>;
  fromModule?: InputMaybe<Scalars["String"]>;
  id: Scalars["String"];
};

export type MultipartUploadInput = {
  eTag: Scalars["String"];
  partNumber: Scalars["Int"];
};

export type Mutation = {
  __typename?: "Mutation";
  /** Record the requesting user's acknowledgment of the current Community Guidelines version. Requires the user role to use. */
  acknowledgeCommunityGuidelines: User;
  /** Create a comment. */
  activityCommentCreate: ActivityComment;
  /** Delete a comment. */
  activityCommentDelete: Scalars["Boolean"];
  /** Update a comment body. */
  activityCommentUpdate: ActivityComment;
  /** Create a reaction. */
  activityReactionCreate: ActivityReaction;
  /** Delete a reaction. */
  activityReactionDelete: Scalars["Boolean"];
  /** @deprecated Use addClassesForSchedulePlaylistV2 */
  addClassesForSchedulePlaylist?: Maybe<Playlist>;
  addClassesForSchedulePlaylistV2?: Maybe<Playlist>;
  /** Add a required studio class to an achievement. Requires the admin role to use. */
  adminAchievementAddStudioClass: AdminAchievement;
  /** Create an achievement. Requires the admin role to use. */
  adminAchievementCreate: AdminAchievement;
  /** Delete an achievement and its associated badges. Requires the admin role to use. */
  adminAchievementDelete: Scalars["Boolean"];
  /** Remove challenge from an achievement. Requires the admin role to use. */
  adminAchievementRemoveChallenge: AdminAchievement;
  /** Remove a required studio class from an achievement. Requires the admin role to use. */
  adminAchievementRemoveStudioClass: AdminAchievement;
  /** Update an achievement. Requires the admin role to use. */
  adminAchievementUpdate: AdminAchievement;
  /** Add playlist to featured list Requires the admin role to use. */
  adminAddFeaturedPlaylist: FeaturedPlaylist;
  /** Add studio class to featured list Requires the admin role to use. */
  adminAddFeaturedStudioClass: FeaturedStudioClass;
  /** Upload badge image file. Requires the admin role to use. */
  adminBadgeAssetUploadCreate: CreateAssetUploadResponse;
  /** Create a badge. Requires the admin role to use. */
  adminBadgeCreate: Badge;
  /** Delete a badge. Requires the admin role to use. */
  adminBadgeDelete: Scalars["Boolean"];
  /** Update a badge. Requires the admin role to use. */
  adminBadgeUpdate: Badge;
  /** Upload category image file. Requires the admin role to use. */
  adminCategoryAssetUploadCreate: CreateAssetUploadResponse;
  /** Create a category. Requires the admin role to use. */
  adminCategoryCreate: ClassCategory;
  /** Upload the Explore Styles tile SVG for a category (stored at the slug-keyed path and served via the CDN). Requires the admin role to use. */
  adminCategoryTileImageUpload: CategoryTileImageUploadResponse;
  /** Update a category. Requires the admin role to use. */
  adminCategoryUpdate: ClassCategory;
  /** Complete a category video file upload. Requires the admin role to use. */
  adminCategoryVideoFileUploadComplete: AdminCategoryVideo;
  /** Initiate a category video file upload. Requires the admin role to use. */
  adminCategoryVideoFileUploadCreate: VideoUploadCreateResponse;
  /** Create a class style. Requires the admin role to use. */
  adminClassStyleCreate: ClassStyle;
  /** Delete a class style. Only allowed when no classes use it. Requires the admin role to use. */
  adminClassStyleDelete: Scalars["Boolean"];
  /** Update a class style. Slug is immutable. Requires the admin role to use. */
  adminClassStyleUpdate: ClassStyle;
  /** Assign a plan to a country Requires the admin role to use. */
  adminCountryAssignPlan: Country;
  /** Create a new country Requires the admin role to use. */
  adminCountryCreate: Country;
  /** Delete a country Requires the admin role to use. */
  adminCountryDelete: Scalars["Boolean"];
  /** Update an existing country Requires the admin role to use. */
  adminCountryUpdate: Country;
  /** Upload instructor image file. Requires the admin role to use. */
  adminInstructorAssetUploadCreate: CreateAssetUploadResponse;
  /** Create an instructor. Requires the admin role to use. */
  adminInstructorCreate: ClassInstructor;
  /** Update an instructor. Requires the admin role to use. */
  adminInstructorUpdate: ClassInstructor;
  /** Assign a country to a plan Requires the admin role to use. */
  adminPlanAssignCountry: Plan;
  /** Remove a country from a plan Requires the admin role to use. */
  adminPlanRemoveCountry: Plan;
  /** Update plan display and access settings Requires the admin role to use. */
  adminPlanUpdateSettings: Plan;
  /** Add studio class to playlist. Requires the admin role to use. */
  adminPlaylistAddClass: Scalars["Boolean"];
  /** Upload playlist image file. Requires the admin role to use. */
  adminPlaylistAssetUploadCreate: CreateAssetUploadResponse;
  /** Create a playlist. Requires the admin role to use. */
  adminPlaylistCreate: PlaylistV2;
  /** Remove studio class from playlist. Requires the admin role to use. */
  adminPlaylistRemoveClass: Scalars["Boolean"];
  /** Update a playlist. Requires the admin role to use. */
  adminPlaylistUpdate: PlaylistV2;
  /** Create a new program. Requires the admin role to use. */
  adminProgramCreate: AdminProgram;
  /** Delete a program. Requires the admin role to use. */
  adminProgramDelete: Scalars["Boolean"];
  /** Publish a program. Requires the admin role to use. */
  adminProgramPublish: AdminProgram;
  /** Unpublish a program. Requires the admin role to use. */
  adminProgramUnPublish: AdminProgram;
  /** Update a program. Requires the admin role to use. */
  adminProgramUpdate?: Maybe<AdminProgram>;
  /** Remove playlist from featured list Requires the admin role to use. */
  adminRemoveFeaturedPlaylist: Scalars["Boolean"];
  /** Remove studio class from featured list Requires the admin role to use. */
  adminRemoveFeaturedStudioClass: Scalars["Boolean"];
  /** Add a track to a class. Requires the admin role to use. */
  adminStudioClassAddTrack: AdminStudioClass;
  /** Upload class image file. Requires the admin role to use. */
  adminStudioClassAssetUploadCreate: CreateAssetUploadResponse;
  /** Create a class. Slug for class is auto-generated. Requires the admin role to use. */
  adminStudioClassCreate: AdminStudioClass;
  /** Publish a studio class Requires the admin role to use. */
  adminStudioClassPublish: AdminStudioClass;
  /** Remove a track from a class. Requires the admin role to use. */
  adminStudioClassRemoveTrack: AdminStudioClass;
  /** Un-publish a studio class. Requires the admin role to use. */
  adminStudioClassUnPublish: AdminStudioClass;
  /** Update a class. Requires the admin role to use. */
  adminStudioClassUpdate?: Maybe<AdminStudioClass>;
  /** Create content tag. Requires the admin role to use. */
  adminTagCreate: Tag;
  /** Update content tag. Requires the admin role to use. */
  adminTagUpdate: Tag;
  /** Update featured studio classes order Requires the admin role to use. */
  adminUpdateFeaturedClassesOrder: Scalars["Boolean"];
  /** Update featured playlists order Requires the admin role to use. */
  adminUpdateFeaturedPlaylistsOrder: Scalars["Boolean"];
  /** Deletes user's PII. Requires the admin role to use. */
  adminUserAuthDelete: Scalars["Boolean"];
  /** Returns a Firebase Custom Token for user Requires the admin role to use. */
  adminUserAutoLoginToken: Scalars["String"];
  /** Create a randomized personalized playlist Requires the admin role to use. */
  adminUserRandomizePersonalizedPlaylist: Scalars["String"];
  /** Sync user's RevenueCat subscription with our database. Requires the admin role to use. */
  adminUserSyncRevenueCat: Scalars["Boolean"];
  /** Update a user's login credentials. Requires the admin role to use. */
  adminUserUpdateLogin: Scalars["String"];
  approvePartyMember: SuccessPayload;
  /** Calculate progress for all active challenges and return newly earned badges Requires the user role to use. */
  calculateChallengesProgress: ChallengeProgressResult;
  /** Upload challenge thumbnail image. Requires the admin role to use. */
  challengeAssetUploadCreate: CreateAssetUploadResponse;
  /** Create a challenge. Requires the admin role to use. */
  challengeCreate: Challenge;
  /** Delete a challenge. Requires the admin role to use. */
  challengeDelete: Challenge;
  /** Update a challenge. Requires the admin role to use. */
  challengeUpdate: Challenge;
  /** Creates a comment for a class given a studioClassId Requires the user role to use. */
  classCommentCreate: ActivityComment;
  /** Unlock the class for the requesting user. Requires the user role to use. */
  classUnlock: Class;
  /** Complete class video file upload. Requires the admin role to use. */
  classVideoFileUploadComplete: ClassVideo;
  /** Initiate class video file upload. Requires the admin role to use. */
  classVideoFileUploadCreate: VideoUploadCreateResponse;
  /** @deprecated Use completeClassV2 */
  completeClass: SuccessPayload;
  completeClassV2: Class;
  /** Create or update a cancel survey for a subscription Requires the user role to use. */
  createCancelSurvey: CancelSurvey;
  createParty: CreatePartyOutput;
  /** @deprecated Use createRecommendedSchedulePlaylistV2 */
  createRecommendedSchedulePlaylist?: Maybe<Playlist>;
  createRecommendedSchedulePlaylistV2?: Maybe<Playlist>;
  /** @deprecated Use createSchedulePlaylistV2 */
  createSchedulePlaylist?: Maybe<Playlist>;
  createSchedulePlaylistV2?: Maybe<Playlist>;
  /** Create a user. Requires the user role to use. */
  createUser: User;
  endParty: SuccessPayload;
  /** Create a flagged activity (report on content). Requires the user role to use. */
  flaggedActivityCreate: FlaggedActivity;
  /** Review a flagged activity. Requires the admin role to use. */
  flaggedActivityReview: FlaggedActivity;
  /** Follows a list of categories for given slugs. Applies to the currently authenticated user. */
  followCategories: Array<FollowCategoryOutput>;
  /** Follows a category for a given slug. Applies to the currently authenticated user. */
  followCategory: FollowCategoryOutput;
  /** Follows a class given an ID for the currently authenticated user. */
  followClass: FollowClassOutput;
  /** Follows an instructor given a slug for the currently authenticated user. */
  followInstructor: FollowInstructorOutput;
  /** Collect payment on invoice. Requires the user role to use. */
  invoiceCollectPayment: Invoice;
  /** Collect payment on invoice using Stripe. Requires the user role to use. */
  invoiceCollectPaymentStripe: Invoice;
  joinParty: JoinPartyOutput;
  leaveParty: LeavePartyOutput;
  leavePartyQueue: SuccessPayload;
  /** Create a play session. */
  playSessionCreate: Scalars["String"];
  /** Refresh a play session. */
  playSessionRefresh: Scalars["Boolean"];
  /** Add studio class to playlist. Requires the user role to use. */
  playlistAddStudioClass: PlaylistHasStudioClass;
  /** Create user playlist. Requires the user role to use. */
  playlistCreate: PlaylistV2;
  /** Delete playlist. Requires the user role to use. */
  playlistDelete: Scalars["Boolean"];
  /** Remove studio class from playlist. Requires the user role to use. */
  playlistRemoveStudioClass: PlaylistHasStudioClass;
  /** Follow a playlist. Requires the user role to use. */
  playlistSave: Scalars["Boolean"];
  /** Unfollow a playlist. Requires the user role to use. */
  playlistUnsave: Scalars["Boolean"];
  /** Update playlist details. Requires the user role to use. */
  playlistUpdateDetails: PlaylistV2;
  queuePartyMember: QueuePartyMemberOutput;
  /** Saves a user's rating for a class as a numeric value between 1 and 5. */
  rateClass: RateClassOutput;
  /** @deprecated Use removeClassesForSchedulePlaylistV2 */
  removeClassesForSchedulePlaylist?: Maybe<Playlist>;
  removeClassesForSchedulePlaylistV2?: Maybe<Playlist>;
  /** @deprecated Use removeTakenClassV2 */
  removeTakenClass: SuccessPayload;
  /** Removes a class from a user's list of taken classes for a specified date */
  removeTakenClassV2: SuccessPayload;
  /** Refresh session for requesting user. Requires the user role to use. */
  sessionRefresh?: Maybe<Scalars["String"]>;
  /** Given a family goal slug, set the family goal preference for a user. */
  setAccountTypePreference: AccountTypeOption;
  /**
   * Given a class duration slug, set the dance reason preference for a user.
   * @deprecated Duration options no longer relevant
   */
  setClassDurationPreference: DurationOption;
  /** Set dance cadence for user. Requires the user role to use. */
  setDanceCadencePreference: Scalars["Boolean"];
  /** Set dance energy for user. Requires the user role to use. */
  setDanceEnergyPreference: Scalars["Boolean"];
  /**
   * Set dance frequency for user. Requires the user role to use.
   * @deprecated Renaming. Use setDanceHabitPreference instead.
   */
  setDanceFrequencyPreference: Scalars["Boolean"];
  /** Set dance goals for user. Requires the user role to use. */
  setDanceGoalsPreference: Scalars["Boolean"];
  /** Set dance habit for user. Requires the user role to use. */
  setDanceHabitPreference: Scalars["Boolean"];
  /** Given a dance level slug, set the dance level preference for a user. */
  setDanceLevelPreference: LevelOption;
  /** Set dance level for user. Requires the user role to use. */
  setDanceLevelPreferenceV2: Scalars["Boolean"];
  /** Set dance locations for user. Requires the user role to use. */
  setDanceLocationsPreference: Scalars["Boolean"];
  /** Given a account type slug, set the account type preference for a user. */
  setDanceReasonPreference: ReasonOption;
  setExperiment: SetExperimentOutput;
  /** Given a dance reason slug, set the dance level preference for a user. */
  setFamilyGoalPreference: FamilyGoalOption;
  /** Set HDYHAU survey response slugs for user. Requires the user role to use. */
  setHDYHAUSurveyResponse: Scalars["Boolean"];
  /**
   * Sets a date seen for a featured content modal
   * @deprecated Use userAcknowledgeContent on Jarvis
   */
  setSeenModalDate: SuccessPayload;
  /** Set user age. Requires the user role to use. */
  setUserAgeResponse: Scalars["Boolean"];
  setUsersTimezone: SuccessPayload;
  /** @deprecated Use startClassV2 */
  startClass: SuccessPayload;
  startClassV2: Class;
  /** Allows user to submit feedback when canceling their subscription */
  submitCancelationFeedback: SuccessPayload;
  /** Cancel a subscription for the requesting user. Requires the user role to use. */
  subscriptionCancel: Subscription;
  /** Create a subscription for the requesting user (Chargebee only). Requires the user role to use. */
  subscriptionCreate: Subscription;
  /** Create a subscription for existing customer. Requires the user role to use. */
  subscriptionCreateForCustomer: Subscription;
  /** Create a subscription for the requesting user. Requires the user role to use. */
  subscriptionCreateV2: UserSubscription;
  /** Extend a trial for a subscription. Requires the user role to use. */
  subscriptionExtendTrial: Subscription;
  /** Pause a subscription for the requesting user. Requires the user role to use. */
  subscriptionPause: Subscription;
  /** Reactivate a subscription for the requesting user. Requires the user role to use. */
  subscriptionReactivate: Subscription;
  /** Reactivate a canceled subscription by applying coupons. Requires the user role to use. */
  subscriptionReactivateUsingCoupon: Subscription;
  /** Remove scheduled changes for the requesting user's subscription. Requires the user role to use. */
  subscriptionRemoveScheduledChanges: Subscription;
  /** Resume a subscription for the requesting user. Requires the user role to use. */
  subscriptionResume: Subscription;
  /** Switch a requesting users's subscription plan. Requires the user role to use. */
  subscriptionSwitchPlan: Subscription;
  /** Upgrade a subscription from a monthly to a yearly plan for the requesting user. Requires the user role to use. */
  subscriptionUpgrade: Subscription;
  timeoutPartyMember: SuccessPayload;
  /** Toggles a program class as complete or incomplete based on the given input */
  toggleClassComplete: ProgramV2;
  toggleNotifications?: Maybe<ToggleNotificationsOutput>;
  /** Allows users to save or unsave a class based on given input */
  toggleSaveClass: Class;
  /** Allows users to save or unsave a program based on given input */
  toggleSaveProgram: ProgramV2;
  /** Log a play event for a track. Requires the user role to use. */
  trackLogPlay: Scalars["Boolean"];
  /** Create a track. If track ISRC/song ID is from Tuned Global, data is pulled from there. Requires the admin role to use. */
  trackUpsert: Track;
  /**
   * Updates the class progress for a user. This mutation should be invoked every 10 seconds. It should not be invoked when the class video is paused.
   * It should be invoked immediately when the user navigates away from the video or the application.
   * @deprecated Use updateClassProgressV2
   */
  updateClassProgress: SuccessPayload;
  updateClassProgressV2: Class;
  /** @deprecated Use updateClassSessionV2 */
  updateClassSession: SuccessPayload;
  updateClassSessionV2: Class;
  /** @deprecated Use updateSchedulePlaylistV2 */
  updateSchedulePlaylist?: Maybe<Playlist>;
  updateSchedulePlaylistV2?: Maybe<Playlist>;
  /** License or unlicense a track. Requires the admin role to use. */
  updateTrackLicense: Track;
  /** Update the user's profile information. Requires the user role to use. */
  updateUserProfile: UserProfile;
  /** Updates the users last_seen property to the current date in UTC ISO8601. */
  updateUsersLastSeen: SuccessPayload;
  updateWeeklyStreakGoal: WeeklyStreakGoalOutput;
  /** Saves a datetime when a user acknowledges content. Requires the user role to use. */
  userAcknowledgeContent: User;
  /** Updates a user's apple authorization code and refresh token. Requires the user role to use. */
  userAuthUpdate: Scalars["Boolean"];
  /** Block another user. Hides the blocked user's content from the requester's feeds and prevents them from interacting with the requester's posts. Requires the user role to use. */
  userBlockCreate: UserBlock;
  /** Remove an existing block. Returns true even when no block existed (idempotent). Requires the user role to use. */
  userBlockRemove: Scalars["Boolean"];
  /** Allow community access to multiple users (by email). Requires the admin role to use. */
  userBulkEnableCommunity: Scalars["Float"];
  /** Check if a username exists. Requires the user role to use. */
  userCheckUsername: UserUsername;
  /** Unlock a class for the requesting user. Requires the user role to use. */
  userClassUnlock: User;
  /** Create a referral invite for the requesting user. Requires the user role to use. */
  userCreateReferralInvite: User;
  /** Update user's notification preference Requires the user role to use. */
  userNotificationPreferenceUpdate: NotificationPreference;
  /** Remove a photo for the requesting user. Requires the user role to use. */
  userRemovePhoto: User;
  /** Set parental controls for a user. Requires the user role to use. */
  userSetParentalControls: User;
  /** Set a photo for the requesting user. Requires the user role to use. */
  userSetPhoto: User;
  /** Sets user's username */
  userSetUsername: User;
  /** Update a user. Requires the admin role to use. */
  userUpdate: User;
  /** Update the birth date for the requesting user. Requires the user role to use. */
  userUpdateBirthDate: User;
  /** Update the name for the requesting user. Requires the user role to use. */
  userUpdateName: User;
  /** Update the primary payment source (card only) for the requesting user. Requires the user role to use. */
  userUpdatePaymentSource: User;
  /** Update a user's username. Requires the user role to use. */
  userUpdateUsername: UserUsername;
  /** Update a UGC video approval status. Requires the admin role to use. */
  videoUploadAdminUpdate: VideoUpload;
  /** Complete a UGC video file upload. */
  videoUploadComplete: VideoUpload;
  /** Initiate a UGC video file upload. */
  videoUploadCreate: VideoUploadCreateResponse;
  /** Delete a UGC video. Requires the user role to use. */
  videoUploadDelete: VideoUpload;
  /** Submit a UGC video (post it). */
  videoUploadSubmit: VideoUpload;
  /** Update a UGC video description. */
  videoUploadUpdate: VideoUpload;
};

export type MutationActivityCommentCreateArgs = {
  input: ActivityCommentCreateInput;
};

export type MutationActivityCommentDeleteArgs = {
  commentId: Scalars["String"];
};

export type MutationActivityCommentUpdateArgs = {
  input: ActivityCommentUpdateInput;
};

export type MutationActivityReactionCreateArgs = {
  input: ActivityReactionCreateInput;
};

export type MutationActivityReactionDeleteArgs = {
  input: ActivityReactionDeleteInput;
};

export type MutationAddClassesForSchedulePlaylistArgs = {
  input: ModifyPlaylistInput;
};

export type MutationAddClassesForSchedulePlaylistV2Args = {
  input: ModifyPlaylistInputV2;
};

export type MutationAdminAchievementAddStudioClassArgs = {
  input: AchievementStudioClassInput;
};

export type MutationAdminAchievementCreateArgs = {
  input: AchievementCreateInput;
};

export type MutationAdminAchievementDeleteArgs = {
  id: Scalars["String"];
};

export type MutationAdminAchievementRemoveChallengeArgs = {
  achievementId: Scalars["String"];
};

export type MutationAdminAchievementRemoveStudioClassArgs = {
  input: AchievementStudioClassInput;
};

export type MutationAdminAchievementUpdateArgs = {
  input: AchievementUpdateInput;
};

export type MutationAdminAddFeaturedPlaylistArgs = {
  playlistId: Scalars["ID"];
};

export type MutationAdminAddFeaturedStudioClassArgs = {
  classId?: InputMaybe<Scalars["Int"]>;
  id?: InputMaybe<Scalars["ID"]>;
};

export type MutationAdminBadgeAssetUploadCreateArgs = {
  assetType: BadgeAssetType;
  contentType: Scalars["String"];
};

export type MutationAdminBadgeCreateArgs = {
  input: BadgeCreateInput;
};

export type MutationAdminBadgeDeleteArgs = {
  id: Scalars["String"];
};

export type MutationAdminBadgeUpdateArgs = {
  input: BadgeUpdateInput;
};

export type MutationAdminCategoryAssetUploadCreateArgs = {
  assetType: CategoryAssetType;
};

export type MutationAdminCategoryCreateArgs = {
  input: CategoryCreateInput;
};

export type MutationAdminCategoryTileImageUploadArgs = {
  input: CategoryTileImageUploadInput;
};

export type MutationAdminCategoryUpdateArgs = {
  input: CategoryUpdateInput;
};

export type MutationAdminCategoryVideoFileUploadCompleteArgs = {
  input: VideoUploadCompleteInput;
};

export type MutationAdminCategoryVideoFileUploadCreateArgs = {
  input: CategoryVideoFileCreateInput;
};

export type MutationAdminClassStyleCreateArgs = {
  input: ClassStyleCreateInput;
};

export type MutationAdminClassStyleDeleteArgs = {
  classStyleId: Scalars["String"];
};

export type MutationAdminClassStyleUpdateArgs = {
  input: ClassStyleUpdateInput;
};

export type MutationAdminCountryAssignPlanArgs = {
  input: AssignPlanToCountryInput;
};

export type MutationAdminCountryCreateArgs = {
  input: CreateCountryInput;
};

export type MutationAdminCountryDeleteArgs = {
  id: Scalars["String"];
};

export type MutationAdminCountryUpdateArgs = {
  id: Scalars["String"];
  input: UpdateCountryInput;
};

export type MutationAdminInstructorAssetUploadCreateArgs = {
  assetType: InstructorAssetType;
};

export type MutationAdminInstructorCreateArgs = {
  input: InstructorCreateInput;
};

export type MutationAdminInstructorUpdateArgs = {
  input: InstructorUpdateInput;
};

export type MutationAdminPlanAssignCountryArgs = {
  input: AssignPlanToCountryInput;
};

export type MutationAdminPlanRemoveCountryArgs = {
  input: RemovePlanFromCountryInput;
};

export type MutationAdminPlanUpdateSettingsArgs = {
  id: Scalars["String"];
  input: UpdatePlanSettingsInput;
};

export type MutationAdminPlaylistAddClassArgs = {
  input: PlaylistAddOrRemoveStudioClassInput;
};

export type MutationAdminPlaylistAssetUploadCreateArgs = {
  assetType: PlaylistAssetType;
};

export type MutationAdminPlaylistCreateArgs = {
  name: Scalars["String"];
};

export type MutationAdminPlaylistRemoveClassArgs = {
  input: PlaylistAddOrRemoveStudioClassInput;
};

export type MutationAdminPlaylistUpdateArgs = {
  input: PlaylistUpdateInput;
};

export type MutationAdminProgramCreateArgs = {
  input: ProgramCreateInput;
};

export type MutationAdminProgramDeleteArgs = {
  slug: Scalars["String"];
};

export type MutationAdminProgramPublishArgs = {
  slug: Scalars["String"];
};

export type MutationAdminProgramUnPublishArgs = {
  slug: Scalars["String"];
};

export type MutationAdminProgramUpdateArgs = {
  input: ProgramUpdateInput;
};

export type MutationAdminRemoveFeaturedPlaylistArgs = {
  id: Scalars["ID"];
};

export type MutationAdminRemoveFeaturedStudioClassArgs = {
  id: Scalars["ID"];
};

export type MutationAdminStudioClassAddTrackArgs = {
  input: ClassTrackInput;
};

export type MutationAdminStudioClassAssetUploadCreateArgs = {
  assetType: StudioClassAssetType;
};

export type MutationAdminStudioClassCreateArgs = {
  input: StudioClassCreateInput;
};

export type MutationAdminStudioClassPublishArgs = {
  studioClassId: Scalars["String"];
};

export type MutationAdminStudioClassRemoveTrackArgs = {
  input: ClassTrackInput;
};

export type MutationAdminStudioClassUnPublishArgs = {
  studioClassId: Scalars["String"];
};

export type MutationAdminStudioClassUpdateArgs = {
  input: StudioClassUpdateInput;
};

export type MutationAdminTagCreateArgs = {
  input: TagCreateInput;
};

export type MutationAdminTagUpdateArgs = {
  input: TagUpdateInput;
};

export type MutationAdminUpdateFeaturedClassesOrderArgs = {
  items: Array<Scalars["String"]>;
};

export type MutationAdminUpdateFeaturedPlaylistsOrderArgs = {
  items: Array<Scalars["String"]>;
};

export type MutationAdminUserAuthDeleteArgs = {
  input: UserAuthDeleteInput;
};

export type MutationAdminUserAutoLoginTokenArgs = {
  uid: Scalars["String"];
};

export type MutationAdminUserRandomizePersonalizedPlaylistArgs = {
  input: UserRandomizePersonalizedPlaylistInput;
};

export type MutationAdminUserSyncRevenueCatArgs = {
  input: AdminUserSyncRevenueCatInput;
};

export type MutationAdminUserUpdateLoginArgs = {
  input: AdminUserUpdateLogin;
};

export type MutationApprovePartyMemberArgs = {
  input: ApprovePartyMemberInput;
};

export type MutationCalculateChallengesProgressArgs = {
  triggerType: AchievementTriggerType;
};

export type MutationChallengeCreateArgs = {
  input: ChallengeCreateInput;
};

export type MutationChallengeDeleteArgs = {
  challengeId: Scalars["String"];
};

export type MutationChallengeUpdateArgs = {
  input: ChallengeUpdateInput;
};

export type MutationClassCommentCreateArgs = {
  input: ActivityClassCommentCreateInput;
};

export type MutationClassUnlockArgs = {
  input: ClassUnlockInput;
};

export type MutationClassVideoFileUploadCompleteArgs = {
  input: VideoUploadCompleteInput;
};

export type MutationClassVideoFileUploadCreateArgs = {
  input: ClassVideoFileCreateInput;
};

export type MutationCompleteClassArgs = {
  input: ClassCompleteInput;
};

export type MutationCompleteClassV2Args = {
  input: ClassCompleteInput;
};

export type MutationCreateCancelSurveyArgs = {
  input: CancelSurveyInput;
};

export type MutationCreatePartyArgs = {
  input: CreatePartyInput;
};

export type MutationCreateRecommendedSchedulePlaylistArgs = {
  input: CreateRecommendedSchedulePlaylistInput;
};

export type MutationCreateRecommendedSchedulePlaylistV2Args = {
  input: CreateRecommendedSchedulePlaylistInput;
};

export type MutationCreateSchedulePlaylistArgs = {
  input: CreateSchedulePlaylistInput;
};

export type MutationCreateSchedulePlaylistV2Args = {
  input: CreateSchedulePlaylistInputV2;
};

export type MutationCreateUserArgs = {
  input: UserCreateInput;
};

export type MutationEndPartyArgs = {
  input: PartyInput;
};

export type MutationFlaggedActivityCreateArgs = {
  input: FlaggedActivityCreateInput;
};

export type MutationFlaggedActivityReviewArgs = {
  input: FlaggedActivityReviewInput;
};

export type MutationFollowCategoriesArgs = {
  input: FollowCategoriesInput;
};

export type MutationFollowCategoryArgs = {
  input: FollowCategoryInput;
};

export type MutationFollowClassArgs = {
  input: FollowClassInput;
};

export type MutationFollowInstructorArgs = {
  input: FollowInstructorInput;
};

export type MutationInvoiceCollectPaymentArgs = {
  input: CollectPaymentInput;
};

export type MutationInvoiceCollectPaymentStripeArgs = {
  input: StripeCollectPaymentInput;
};

export type MutationJoinPartyArgs = {
  input: PartyInput;
};

export type MutationLeavePartyArgs = {
  input: PartyInput;
};

export type MutationLeavePartyQueueArgs = {
  input: PartyInput;
};

export type MutationPlaySessionRefreshArgs = {
  playSessionId: Scalars["String"];
};

export type MutationPlaylistAddStudioClassArgs = {
  input: PlaylistAddOrRemoveStudioClassInput;
};

export type MutationPlaylistCreateArgs = {
  input: PlaylistCreateInput;
};

export type MutationPlaylistDeleteArgs = {
  input: PlaylistDeleteInput;
};

export type MutationPlaylistRemoveStudioClassArgs = {
  input: PlaylistAddOrRemoveStudioClassInput;
};

export type MutationPlaylistSaveArgs = {
  input: PlaylistSaveOrUnsaveInput;
};

export type MutationPlaylistUnsaveArgs = {
  input: PlaylistSaveOrUnsaveInput;
};

export type MutationPlaylistUpdateDetailsArgs = {
  input: PlaylistUpdateDetailsInput;
};

export type MutationQueuePartyMemberArgs = {
  input: PartyInput;
};

export type MutationRateClassArgs = {
  input: RateClassInput;
};

export type MutationRemoveClassesForSchedulePlaylistArgs = {
  input: ModifyPlaylistInput;
};

export type MutationRemoveClassesForSchedulePlaylistV2Args = {
  input: ModifyPlaylistInputV2;
};

export type MutationRemoveTakenClassArgs = {
  input: RemoveTakenClassInput;
};

export type MutationRemoveTakenClassV2Args = {
  input: RemoveTakenClassInputV2;
};

export type MutationSessionRefreshArgs = {
  input?: InputMaybe<UserSessionInput>;
};

export type MutationSetAccountTypePreferenceArgs = {
  input: SetAccountTypePreferenceInput;
};

export type MutationSetClassDurationPreferenceArgs = {
  input: SetClassDurationPreferenceInput;
};

export type MutationSetDanceCadencePreferenceArgs = {
  input: SetDanceCadenceInput;
};

export type MutationSetDanceEnergyPreferenceArgs = {
  input: SetDanceEnergyInput;
};

export type MutationSetDanceFrequencyPreferenceArgs = {
  input: SetDanceFrequencyInput;
};

export type MutationSetDanceGoalsPreferenceArgs = {
  input: SetDanceGoalsInput;
};

export type MutationSetDanceHabitPreferenceArgs = {
  input: SetDanceHabitInput;
};

export type MutationSetDanceLevelPreferenceArgs = {
  input: SetDanceLevelPreferenceInput;
};

export type MutationSetDanceLevelPreferenceV2Args = {
  input: SetDanceLevelInput;
};

export type MutationSetDanceLocationsPreferenceArgs = {
  input: SetDanceLocationsInput;
};

export type MutationSetDanceReasonPreferenceArgs = {
  input: SetDanceReasonPreferenceInput;
};

export type MutationSetExperimentArgs = {
  input: SetExperimentInput;
};

export type MutationSetFamilyGoalPreferenceArgs = {
  input: SetFamilyGoalPreferenceInput;
};

export type MutationSetHdyhauSurveyResponseArgs = {
  input: SetHdyhauSurveyResponseInput;
};

export type MutationSetSeenModalDateArgs = {
  input: FeaturedModalSlugInput;
};

export type MutationSetUserAgeResponseArgs = {
  input: SetUserAgeInput;
};

export type MutationSetUsersTimezoneArgs = {
  input: SetUsersTimezoneInput;
};

export type MutationStartClassArgs = {
  input: ClassStartInput;
};

export type MutationStartClassV2Args = {
  input: ClassStartInput;
};

export type MutationSubmitCancelationFeedbackArgs = {
  input: SubmitCancelationFeedbackInput;
};

export type MutationSubscriptionCancelArgs = {
  input: SubscriptionCancelInput;
};

export type MutationSubscriptionCreateArgs = {
  input: SubscriptionCreateInput;
};

export type MutationSubscriptionCreateForCustomerArgs = {
  input: SubscriptionCreateForCustomerInput;
};

export type MutationSubscriptionCreateV2Args = {
  input: SubscriptionCreateInput;
};

export type MutationSubscriptionExtendTrialArgs = {
  input: SubscriptionExtendTrialInput;
};

export type MutationSubscriptionPauseArgs = {
  input: SubscriptionPauseInput;
};

export type MutationSubscriptionReactivateArgs = {
  input: SubscriptionReactivateInput;
};

export type MutationSubscriptionReactivateUsingCouponArgs = {
  input: SubscriptionReactivateUsingCouponInput;
};

export type MutationSubscriptionRemoveScheduledChangesArgs = {
  input: SubscriptionRemoveScheduledChangesInput;
};

export type MutationSubscriptionResumeArgs = {
  input: SubscriptionResumeInput;
};

export type MutationSubscriptionSwitchPlanArgs = {
  input: SubscriptionSwitchInput;
};

export type MutationSubscriptionUpgradeArgs = {
  input: SubscriptionUpgradeInput;
};

export type MutationTimeoutPartyMemberArgs = {
  input: PartyInput;
};

export type MutationToggleClassCompleteArgs = {
  input: ToggleClassCompleteInput;
};

export type MutationToggleNotificationsArgs = {
  input: ToggleNotificationsInput;
};

export type MutationToggleSaveClassArgs = {
  input: ToggleSaveClassInput;
};

export type MutationToggleSaveProgramArgs = {
  input: ToggleSaveProgramInput;
};

export type MutationTrackLogPlayArgs = {
  input: TrackLogPlayInput;
};

export type MutationTrackUpsertArgs = {
  input: TrackUpsertInput;
};

export type MutationUpdateClassProgressArgs = {
  input: ClassProgressInput;
};

export type MutationUpdateClassProgressV2Args = {
  input: ClassProgressInput;
};

export type MutationUpdateClassSessionArgs = {
  input: ClassSessionInput;
};

export type MutationUpdateClassSessionV2Args = {
  input: ClassSessionInput;
};

export type MutationUpdateSchedulePlaylistArgs = {
  input: ModifyPlaylistInput;
};

export type MutationUpdateSchedulePlaylistV2Args = {
  input: ModifyPlaylistInputV2;
};

export type MutationUpdateTrackLicenseArgs = {
  input: TrackLicenseUpdateInput;
};

export type MutationUpdateUserProfileArgs = {
  input: UserProfileUpdateInput;
};

export type MutationUpdateWeeklyStreakGoalArgs = {
  input: WeeklyStreakGoalInput;
};

export type MutationUserAcknowledgeContentArgs = {
  input?: InputMaybe<UserAcknowledgeContentInput>;
};

export type MutationUserAuthUpdateArgs = {
  input: UserAuthUpdateInput;
};

export type MutationUserBlockCreateArgs = {
  input: UserBlockCreateInput;
};

export type MutationUserBlockRemoveArgs = {
  input: UserBlockRemoveInput;
};

export type MutationUserBulkEnableCommunityArgs = {
  emails: Array<Scalars["String"]>;
};

export type MutationUserCheckUsernameArgs = {
  input: UserCheckUsernameInput;
};

export type MutationUserClassUnlockArgs = {
  input: ClassUnlockInput;
};

export type MutationUserCreateReferralInviteArgs = {
  input: UserCreateReferralInviteInput;
};

export type MutationUserNotificationPreferenceUpdateArgs = {
  input: UserNotificationPreferenceUpdateInput;
};

export type MutationUserSetParentalControlsArgs = {
  input: UserSetParentalControlsInput;
};

export type MutationUserSetPhotoArgs = {
  input: UserSetProfilePhoto;
};

export type MutationUserSetUsernameArgs = {
  input: SetUsernameInput;
};

export type MutationUserUpdateArgs = {
  input: UserUpdateInput;
};

export type MutationUserUpdateBirthDateArgs = {
  input: UserBirthDateInput;
};

export type MutationUserUpdateNameArgs = {
  input: UserNameInput;
};

export type MutationUserUpdatePaymentSourceArgs = {
  input: UserUpdatePaymentSourceInput;
};

export type MutationUserUpdateUsernameArgs = {
  input: UserUpdateUsernameInput;
};

export type MutationVideoUploadAdminUpdateArgs = {
  input: VideoUploadAdminUpdateInput;
};

export type MutationVideoUploadCompleteArgs = {
  input: VideoUploadCompleteInput;
};

export type MutationVideoUploadCreateArgs = {
  input: VideoUploadCreateInput;
};

export type MutationVideoUploadDeleteArgs = {
  videoId: Scalars["String"];
};

export type MutationVideoUploadSubmitArgs = {
  input: VideoUploadSubmitInput;
};

export type MutationVideoUploadUpdateArgs = {
  input: VideoUploadUpdateInput;
};

export type MutedCuepoint = {
  __typename?: "MutedCuepoint";
  endsAtTime: Scalars["String"];
  endsAtTimeSec: Scalars["Int"];
  externalUrl?: Maybe<Scalars["String"]>;
  startsAtTime: Scalars["String"];
  startsAtTimeSec: Scalars["Int"];
};

export type MutedCuepointInput = {
  endsAtTimeSec: Scalars["Int"];
  externalUrl?: InputMaybe<Scalars["String"]>;
  startsAtTimeSec: Scalars["Int"];
};

export type Notification = {
  __typename?: "Notification";
  createdAt: Scalars["DateTime"];
  header: Scalars["String"];
  id: Scalars["ID"];
  message: Scalars["String"];
  seen: Scalars["Boolean"];
  /** Profile details of notification sender Requires the user role to use. */
  senderProfile?: Maybe<UserProfile>;
  sourceParamsCSV: Scalars["String"];
  sourceType: NotificationSourceType;
  timeSince: Scalars["String"];
  updatedAt: Scalars["DateTime"];
};

export type NotificationConnection = {
  __typename?: "NotificationConnection";
  edges: Array<NotificationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type NotificationEdge = {
  __typename?: "NotificationEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: Notification;
};

export type NotificationPreference = {
  __typename?: "NotificationPreference";
  allowAll: Scalars["Boolean"];
  enabled: Scalars["Boolean"];
  /** Currently same value as source */
  id: Scalars["ID"];
  source: NotificationSourcePreference;
};

export enum NotificationSourcePreference {
  EmailFeedback = "email_feedback",
  EmailNews = "email_news",
  EmailReminder = "email_reminder",
  EmailSupport = "email_support",
  PushMessage = "push_message",
  PushNewClass = "push_new_class",
  PushNewFollower = "push_new_follower",
  PushRecommendedClasses = "push_recommended_classes",
  PushReminder = "push_reminder",
  PushUgcComment = "push_ugc_comment",
  PushUgcCommentReply = "push_ugc_comment_reply",
  PushUgcReaction = "push_ugc_reaction",
}

/** Source of the notification */
export enum NotificationSourceType {
  BadgeEarned = "BadgeEarned",
  UgcComment = "UGCComment",
  UgcCommentReply = "UGCCommentReply",
  UgcReactionLike = "UGCReactionLike",
}

export type OnboardingData = {
  __typename?: "OnboardingData";
  /** A list of class duration options. */
  durationOptions: Array<DurationOption>;
  /** A list of dance level options. */
  levelOptions: Array<LevelOption>;
  /** A list of reason option dance preferences. */
  reasonOptions: Array<ReasonOption>;
};

export type OrderByInput = {
  /** The field used when ordering */
  sortBy: Scalars["String"];
  /** The direction by which to sort the results when sorted on the 'orderBy' field. */
  sortOrder: SortOrder;
};

export type PageInfo = {
  __typename?: "PageInfo";
  endCursor?: Maybe<Scalars["String"]>;
  hasNextPage: Scalars["Boolean"];
  hasPreviousPage: Scalars["Boolean"];
  startCursor?: Maybe<Scalars["String"]>;
};

export type PaginationBody = {
  /** The number of results to return per page. */
  count: Scalars["Int"];
  /** The zero-indexed page's results to return. */
  page: Scalars["Int"];
};

export type PaginationInfo = {
  __typename?: "PaginationInfo";
  /** Boolean value describing whether the page input parameter can be incremented to fetch further results. (page < totalPages - 1) */
  hasNextPage: Scalars["Boolean"];
  /** Boolean value describing whether there are previous pages. (page !== 0) */
  hasPreviousPage: Scalars["Boolean"];
  /** The total number of hits matching the search state. */
  hits?: Maybe<Scalars["Int"]>;
  /** The current, zero-indexed page of responses. */
  page: Scalars["Int"];
  /** The total number of pages available for the given request. */
  totalPages: Scalars["Int"];
};

export type ParentalControls = {
  __typename?: "ParentalControls";
  isEnabled: Scalars["Boolean"];
  pin?: Maybe<Scalars["String"]>;
};

export type PartyInput = {
  pid: Scalars["String"];
};

export enum PaymentMethodType {
  ApplePay = "apple_pay",
  Card = "card",
  GooglePay = "google_pay",
  PaypalExpressCheckout = "paypal_express_checkout",
}

export type PaymentSource = {
  __typename?: "PaymentSource";
  card?: Maybe<Card>;
  createdAt: Scalars["DateTime"];
  gateway: GatewayProvider;
  id: Scalars["ID"];
  provider: ProviderInfo;
  type: Scalars["String"];
  updatedAt: Scalars["DateTime"];
  user: User;
};

export type Plan = {
  __typename?: "Plan";
  accessType: AccessType;
  annualSavingsInCents: Scalars["Float"];
  canTrial: Scalars["Boolean"];
  /** The estimate for invoice. Requires the user role to use. */
  changePlanEstimate?: Maybe<ChangePlanEstimate>;
  countries: Array<Country>;
  createdAt: Scalars["DateTime"];
  currencyCode?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  invoiceEstimate?: Maybe<SubscriptionInvoiceEstimate>;
  isBestValue: Scalars["Boolean"];
  isDisplayed: Scalars["Boolean"];
  isLegacy: Scalars["Boolean"];
  isSpecial: Scalars["Boolean"];
  isSubscribed: Scalars["Boolean"];
  monthlyCostInCents?: Maybe<Scalars["Float"]>;
  monthlySavingsInPercent: Scalars["Float"];
  name: Scalars["String"];
  nextBillingAt?: Maybe<Scalars["Float"]>;
  partnerAssetUrl?: Maybe<Scalars["String"]>;
  partnerId?: Maybe<Scalars["String"]>;
  period: Scalars["Float"];
  periodUnit?: Maybe<BillingPeriodUnit>;
  platform: Platform;
  priceInCents?: Maybe<Scalars["Float"]>;
  provider: ProviderInfo;
  trialEndTime?: Maybe<Scalars["Float"]>;
  trialPeriod?: Maybe<Scalars["Float"]>;
  trialPeriodUnit?: Maybe<BillingPeriodUnit>;
  updatedAt: Scalars["DateTime"];
};

export type PlanCanTrialArgs = {
  input?: InputMaybe<PlansInput>;
};

export type PlanChangePlanEstimateArgs = {
  input?: InputMaybe<PlansInput>;
};

export type PlanInvoiceEstimateArgs = {
  input?: InputMaybe<PlansInput>;
};

export type PlanNextBillingAtArgs = {
  input?: InputMaybe<PlansInput>;
};

export type PlanTrialEndTimeArgs = {
  input?: InputMaybe<PlansInput>;
};

export type PlanConnection = {
  __typename?: "PlanConnection";
  edges: Array<PlanEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

/** The plan that a coupon is applicable to */
export enum PlanConstraint {
  All = "all",
  None = "none",
  NotApplicable = "not_applicable",
  Specific = "specific",
}

export type PlanEdge = {
  __typename?: "PlanEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: Plan;
};

export type PlanFilter = {
  accessType?: InputMaybe<AccessType>;
  billingPeriodUnit?: InputMaybe<BillingPeriodUnit>;
  countryIsoCode?: InputMaybe<Scalars["String"]>;
  isDisplayed?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  platform?: InputMaybe<Platform>;
  providerId?: InputMaybe<Scalars["String"]>;
  providerName?: InputMaybe<Scalars["String"]>;
};

export type PlanInfoInput = {
  id: Scalars["String"];
  name: SubscriptionProvider;
};

export type PlansInput = {
  accessType?: InputMaybe<AccessType>;
  countryCode?: InputMaybe<Scalars["String"]>;
  partnerId?: InputMaybe<Scalars["String"]>;
  providerName: SubscriptionProvider;
};

/** The STEEZY device platform. */
export enum Platform {
  Android = "android",
  Ios = "ios",
  Web = "web",
}

export type PlayedFragment = {
  end: Scalars["Int"];
  start: Scalars["Int"];
};

export type Playlist = {
  __typename?: "Playlist";
  classes?: Maybe<Array<Maybe<PlaylistClass>>>;
  date?: Maybe<Scalars["String"]>;
  duration_in_seconds?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["String"]>;
  isGenerated: Scalars["Boolean"];
  lastModifiedDate?: Maybe<Scalars["String"]>;
  progress?: Maybe<PlaylistProgress>;
  schedule_index?: Maybe<Scalars["Int"]>;
  takenClasses?: Maybe<Array<Maybe<Class>>>;
};

export type PlaylistAddOrRemoveStudioClassInput = {
  playlistId: Scalars["String"];
  studioClassId: Scalars["String"];
};

/** Playlist asset types */
export enum PlaylistAssetType {
  Thumbnail = "thumbnail",
}

export type PlaylistClass = {
  __typename?: "PlaylistClass";
  /** Access type to determine user access on class. */
  accessType: AccessType;
  /** The action cuepoints for the class. Requires the user role to use. */
  actionCuepoints: Array<ActionCuepoint>;
  /** True if user has access to class based on given set of criteria. */
  canUserTakeClass: Scalars["Boolean"];
  categories: Array<Scalars["String"]>;
  challenges?: Maybe<Array<Challenge>>;
  /** Returns comments for a class given a studioClassId or classNumber Requires the user role to use. */
  comments?: Maybe<ActivityCommentConnection>;
  createdAt: Scalars["DateTime"];
  duration: Scalars["String"];
  duration_in_seconds: Scalars["Int"];
  /** Returns URL to external preview video. Requires the user role to use. */
  externalPreviewUrl?: Maybe<Scalars["String"]>;
  /** True if the user has taken the playlist class */
  hasTaken: Scalars["Boolean"];
  id: Scalars["ID"];
  instructor?: Maybe<Instructor>;
  /** True if class has licensing rights to all its tracks */
  isClassFullyLicensed: Scalars["Boolean"];
  /** True if this class contains an explicit track. Requires the user role to use. */
  isExplicit?: Maybe<Scalars["Boolean"]>;
  /** The published preview video for the class. Requires the user role to use. */
  isFamilyFriendly: Scalars["Boolean"];
  isFree: Scalars["Boolean"];
  /** True if this class has muted cuepoints. Requires the user role to use. */
  isPreviewVideoMuted?: Maybe<Scalars["Boolean"]>;
  isSaved?: Maybe<Scalars["Boolean"]>;
  /** True if class is unlocked for the authenticated user. Only applies to FUX users. Requires the user role to use. */
  isUnlocked: Scalars["Boolean"];
  level?: Maybe<Scalars["String"]>;
  /** The muted cuepoints for the class. Requires the user role to use. */
  mutedCuepoints: Array<MutedCuepoint>;
  /** The playlist ID the class is associated with */
  playlistId?: Maybe<Scalars["String"]>;
  /** The published preview video for the class. Requires the user role to use. */
  previewVideo?: Maybe<ClassVideo>;
  preview_url: Scalars["String"];
  progress?: Maybe<PlaylistClassProgress>;
  publish_date?: Maybe<Scalars["String"]>;
  /** Represents a program class reference ID when defined */
  refId?: Maybe<Scalars["String"]>;
  /** The class sections Requires the user role to use. */
  sections: Array<StudioClassSectionEntity>;
  slug: Scalars["String"];
  songs?: Maybe<Array<Maybe<Song>>>;
  /** Studio class PK Requires the user role to use. */
  studioClassId: Scalars["String"];
  style?: Maybe<Scalars["String"]>;
  thumbnail?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
  /** The tracks (with full metadata) associated with the class. Requires the user role to use. */
  tracks: Array<StudioClassTrack>;
  type: Scalars["String"];
  updatedAt: Scalars["DateTime"];
  /** The user video uploads for this class. Requires the user role to use. */
  userVideos: VideoUploadConnection;
  /** The published video for the class. Requires the user role to use. */
  video?: Maybe<ClassVideo>;
  /** The class video metadata */
  video_metadata?: Maybe<VideoMetadata>;
};

export type PlaylistClassCommentsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Float"]>;
  last?: InputMaybe<Scalars["Float"]>;
};

export type PlaylistClassUserVideosArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Float"]>;
  last?: InputMaybe<Scalars["Float"]>;
};

export type PlaylistClassVideoArgs = {
  hidden?: InputMaybe<Scalars["Boolean"]>;
};

export type PlaylistClassProgress = {
  __typename?: "PlaylistClassProgress";
  completed?: Maybe<Scalars["String"]>;
};

export type PlaylistCreateInput = {
  hidden: Scalars["Boolean"];
  name: Scalars["String"];
};

export type PlaylistDeleteInput = {
  playlistId: Scalars["String"];
};

export type PlaylistFilterInput = {
  excludeIds?: InputMaybe<Array<Scalars["String"]>>;
  name?: InputMaybe<Scalars["String"]>;
};

export type PlaylistHasStudioClass = {
  __typename?: "PlaylistHasStudioClass";
  hasStudioClass: Scalars["Boolean"];
  id: Scalars["ID"];
  /** For convenience, same as second part of `id`. */
  studioClassId: Scalars["String"];
};

export type PlaylistOwner = {
  __typename?: "PlaylistOwner";
  /** List of badges earned by the user */
  badges?: Maybe<Array<UserBadge>>;
  /** User's self-written biography or description */
  bio?: Maybe<Scalars["String"]>;
  /** User's birth date */
  birthDate?: Maybe<Scalars["DateTime"]>;
  /** Unique identifier for the user profile */
  id: Scalars["ID"];
  /** Slug of the user's instructor profile */
  instructorSlug?: Maybe<Scalars["String"]>;
  /** True if the requesting user has blocked the profile owner. When either direction of a block exists, video/post lists are returned as empty to the requester. */
  isBlockedByMe: Scalars["Boolean"];
  isMe: Scalars["Boolean"];
  /** List of social media or other relevant links */
  links?: Maybe<Array<UserProfileLink>>;
  /** User's name */
  name?: Maybe<Scalars["String"]>;
  /** URL to the user's profile photo */
  photoURL?: Maybe<Scalars["String"]>;
  /** Firebase user ID associated with this profile */
  uid?: Maybe<Scalars["String"]>;
  /** User's chosen display name */
  username?: Maybe<Scalars["String"]>;
};

export type PlaylistProgress = {
  __typename?: "PlaylistProgress";
  completed?: Maybe<Scalars["String"]>;
  seen_completed_modal?: Maybe<Scalars["String"]>;
  started?: Maybe<Scalars["String"]>;
};

export type PlaylistSaveOrUnsaveInput = {
  playlistId: Scalars["String"];
};

export type PlaylistUpdateDetailsInput = {
  hidden?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  playlistId: Scalars["String"];
};

export type PlaylistUpdateInput = {
  displayIndex?: InputMaybe<Scalars["Float"]>;
  hidden?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  playlistId: Scalars["String"];
  thumbnailImageId?: InputMaybe<Scalars["String"]>;
};

export type PlaylistV2 = {
  __typename?: "PlaylistV2";
  createdAt: Scalars["DateTime"];
  displayIndex?: Maybe<Scalars["Int"]>;
  /** If studio class(es) is in playlist. Requires the user role to use. */
  hasStudioClasses: Array<PlaylistHasStudioClass>;
  hidden: Scalars["Boolean"];
  id: Scalars["ID"];
  /** Is Playlist saved by user. Requires the user role to use. */
  isSaved: Scalars["Boolean"];
  name: Scalars["String"];
  /** Playlist Owner Requires the user role to use. */
  owner?: Maybe<PlaylistOwner>;
  /** Get studio classes in a playlist. Requires the user role to use. */
  studioClasses: StudioClassConnection;
  thumbnailImageId?: Maybe<Scalars["String"]>;
  /** Playlist thumbnail. Requires the user role to use. */
  thumbnailImageUrl?: Maybe<Scalars["String"]>;
  updatedAt: Scalars["DateTime"];
};

export type PlaylistV2HasStudioClassesArgs = {
  studioClassIds: Array<Scalars["String"]>;
};

export type PlaylistV2StudioClassesArgs = {
  pagination: ConnectionArgs;
};

export type PlaylistV2Connection = {
  __typename?: "PlaylistV2Connection";
  edges: Array<PlaylistV2Edge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type PlaylistV2Edge = {
  __typename?: "PlaylistV2Edge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: PlaylistV2;
};

export type PreferredCategory = {
  __typename?: "PreferredCategory";
  classes: Array<Class>;
  name: Scalars["String"];
  slug: Scalars["String"];
};

export type PreferredContent = {
  __typename?: "PreferredContent";
  categories: Array<PreferredCategory>;
  programs: Array<ProgramV2>;
};

export type Program = {
  __typename?: "Program";
  about_instructor?: Maybe<Scalars["String"]>;
  benefits: Array<Scalars["String"]>;
  /** A list of associated category slugs. */
  categories: Array<Scalars["String"]>;
  completed_classes?: Maybe<Scalars["Int"]>;
  description: Scalars["String"];
  difficulty: Scalars["String"];
  duration_in_seconds: Scalars["Int"];
  instructor?: Maybe<Instructor>;
  /** Set to true if this program is at least partially free to unsubscribed users. */
  isFree: Scalars["Boolean"];
  /** Boolean value describing whether the user has saved the program or not. */
  isSaved?: Maybe<Scalars["Boolean"]>;
  level: Array<Scalars["String"]>;
  preview_url: Scalars["String"];
  progress?: Maybe<ProgramProgress>;
  progression: Array<Maybe<Class>>;
  publish_date?: Maybe<Scalars["String"]>;
  recommendations: Array<Scalars["String"]>;
  slug: Scalars["String"];
  style: Scalars["String"];
  subtitle: Scalars["String"];
  thumbnail?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
  total_classes: Scalars["Int"];
  total_moves?: Maybe<Scalars["Int"]>;
  total_time_spent?: Maybe<Scalars["Int"]>;
};

export type ProgramAssets = {
  __typename?: "ProgramAssets";
  /** The program's preview video URL */
  previewVideoURL?: Maybe<Scalars["String"]>;
  /** The program's thumbnail preview URL */
  thumbnailURL?: Maybe<Scalars["String"]>;
  /** The program's title SVG URL */
  titleSvgURL?: Maybe<Scalars["String"]>;
};

export type ProgramBlock = {
  __typename?: "ProgramBlock";
  progress?: Maybe<ProgramBlockProgress>;
  /** The block ID */
  refId: Scalars["ID"];
  /** The list of sections of a block */
  sections: Array<ProgramSection>;
  /** The number of sections on the block */
  sectionsCount?: Maybe<Scalars["Int"]>;
  /** Where the block is in relation to other blocks of a program */
  sortIndex?: Maybe<Scalars["Int"]>;
  /** The block superscript title */
  superscript?: Maybe<Scalars["String"]>;
  /** The block title */
  title?: Maybe<Scalars["String"]>;
};

export type ProgramBlockInput = {
  refId?: InputMaybe<Scalars["String"]>;
  sections: Array<ProgramSectionInput>;
  superscript?: InputMaybe<Scalars["String"]>;
  title: Scalars["String"];
};

export type ProgramBlockProgress = {
  __typename?: "ProgramBlockProgress";
  /** The percentage of completed classes within the block */
  classesCompletedPercent?: Maybe<Scalars["Int"]>;
  /** True if the block was completed */
  isCompleted?: Maybe<Scalars["Boolean"]>;
  /** The number of sections completed within the block */
  sectionsCompletedCount?: Maybe<Scalars["Int"]>;
};

export type ProgramClassMetadata = {
  __typename?: "ProgramClassMetadata";
  /** The program block the class is associated with */
  block?: Maybe<ProgramBlock>;
  /** True if this is the last class in the program */
  isLastClass?: Maybe<Scalars["Boolean"]>;
  /** The program section the class is associated with */
  section?: Maybe<ProgramSection>;
};

export type ProgramClassProgress = {
  __typename?: "ProgramClassProgress";
  /** True if the class is completed within the program. This value is separate from ClassProgress.complete since user's have the ability to toggle completion for program classes. */
  isCompleted?: Maybe<Scalars["Boolean"]>;
  /** The program slug associated with the class */
  programSlug: Scalars["String"];
};

export type ProgramCreateInput = {
  averageSessionTime?: InputMaybe<Scalars["String"]>;
  blocks?: InputMaybe<Array<ProgramBlockInput>>;
  categories?: InputMaybe<Array<Scalars["String"]>>;
  content?: InputMaybe<Scalars["JSON"]>;
  instructorName?: InputMaybe<Scalars["String"]>;
  instructorSlug?: InputMaybe<Scalars["String"]>;
  isFree?: InputMaybe<Scalars["Boolean"]>;
  level?: InputMaybe<Scalars["String"]>;
  publishDate?: InputMaybe<Scalars["String"]>;
  relatedClasses?: InputMaybe<Array<Scalars["Int"]>>;
  slug: Scalars["String"];
  style?: InputMaybe<Scalars["String"]>;
  title: Scalars["String"];
};

export type ProgramEdge = {
  __typename?: "ProgramEdge";
  /** The program data node. */
  node: Program;
};

export type ProgramOverview = {
  __typename?: "ProgramOverview";
  assets?: Maybe<ProgramAssets>;
  competencies?: Maybe<ProgramOverviewCompetencies>;
  introduction?: Maybe<ProgramOverviewIntroduction>;
  needs?: Maybe<ProgramOverviewNeeds>;
};

export type ProgramOverviewCompetencies = {
  __typename?: "ProgramOverviewCompetencies";
  skills: Array<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
};

export type ProgramOverviewIntroduction = {
  __typename?: "ProgramOverviewIntroduction";
  description?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
};

export type ProgramOverviewNeeds = {
  __typename?: "ProgramOverviewNeeds";
  description?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
};

export type ProgramProgress = {
  __typename?: "ProgramProgress";
  completed?: Maybe<Scalars["String"]>;
  percent?: Maybe<Scalars["Float"]>;
  queued_class?: Maybe<Class>;
  started?: Maybe<Scalars["String"]>;
};

export type ProgramProgressV2 = {
  __typename?: "ProgramProgressV2";
  /** The total number of completed classes in a program */
  completedClassesCount?: Maybe<Scalars["Int"]>;
  /** The date the program was completed */
  completedDate?: Maybe<Scalars["String"]>;
  /** The number of minutes the user spent on the program */
  minutesSpent?: Maybe<Scalars["Float"]>;
  /** The percentage the program is completed (number of classes completed/total classes in program) */
  percentCompleted?: Maybe<Scalars["Float"]>;
  /** The class the user should return to when resuming a program */
  queuedClass?: Maybe<Class>;
  /** The total number of sections completed by the user */
  sectionsCompletedCount?: Maybe<Scalars["Int"]>;
  /** The date the program was started */
  startedDate?: Maybe<Scalars["String"]>;
};

export type ProgramSection = {
  __typename?: "ProgramSection";
  /** The list of classes in a section */
  classes: Array<Class>;
  /** The number of classes on the section */
  classesCount?: Maybe<Scalars["Int"]>;
  /** The length of the section in minutes */
  durationInMins?: Maybe<Scalars["Int"]>;
  progress?: Maybe<ProgramSectionProgress>;
  /** The section ID */
  refId: Scalars["ID"];
  /** Where the section is in relation to other sections of a module */
  sortIndex?: Maybe<Scalars["Int"]>;
  /** The section title */
  title?: Maybe<Scalars["String"]>;
};

export type ProgramSectionClassInput = {
  classId: Scalars["Int"];
  refId?: InputMaybe<Scalars["String"]>;
};

export type ProgramSectionInput = {
  classes: Array<ProgramSectionClassInput>;
  refId?: InputMaybe<Scalars["String"]>;
  title: Scalars["String"];
};

export type ProgramSectionProgress = {
  __typename?: "ProgramSectionProgress";
  /** True if the section was completed */
  isCompleted?: Maybe<Scalars["Boolean"]>;
};

export type ProgramUpdateInput = {
  averageSessionTime?: InputMaybe<Scalars["String"]>;
  blocks?: InputMaybe<Array<ProgramBlockInput>>;
  categories?: InputMaybe<Array<Scalars["String"]>>;
  content?: InputMaybe<Scalars["JSON"]>;
  instructorName?: InputMaybe<Scalars["String"]>;
  instructorSlug?: InputMaybe<Scalars["String"]>;
  isFree?: InputMaybe<Scalars["Boolean"]>;
  level?: InputMaybe<Scalars["String"]>;
  publishDate?: InputMaybe<Scalars["String"]>;
  relatedClasses?: InputMaybe<Array<Scalars["Int"]>>;
  /** Program slug used as lookup key — not updatable */
  slug: Scalars["String"];
  style?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
};

export type ProgramV2 = {
  __typename?: "ProgramV2";
  /** The average amount of time spent per session */
  averageSessionTime?: Maybe<Scalars["String"]>;
  /** A list of blocks within the program */
  blocks: Array<ProgramBlock>;
  /** A list of associated categories with the program */
  categories: Array<Scalars["String"]>;
  /** A list of all the classes on the program */
  classes: Array<Class>;
  /** The markup content describing a program */
  content?: Maybe<ProgramOverview>;
  /** The program instructor */
  instructor?: Maybe<Instructor>;
  /** If true the program is accessible by account-completed users */
  isFree?: Maybe<Scalars["Boolean"]>;
  /** If true the program is saved by the user */
  isSaved?: Maybe<Scalars["Boolean"]>;
  /** The difficulty level of the program */
  level?: Maybe<Scalars["String"]>;
  /** The program's preview URL */
  previewUrl?: Maybe<Scalars["String"]>;
  /** The progress data for the program */
  progress?: Maybe<ProgramProgressV2>;
  /** The date the program was published */
  publishDate?: Maybe<Scalars["String"]>;
  /** A list of related classes to the program */
  relatedClasses: Array<Class>;
  /** The program slug */
  slug: Scalars["ID"];
  /** The style name the program is associated too */
  style?: Maybe<Scalars["String"]>;
  /** The program title */
  title?: Maybe<Scalars["String"]>;
  /** The total number of classes in a program */
  totalClassesCount?: Maybe<Scalars["Int"]>;
  /** The total number of sections in a program */
  totalSectionCount?: Maybe<Scalars["Int"]>;
};

export type ProgramV2ClassesArgs = {
  input?: InputMaybe<ProgramV2ClassesInput>;
};

export type ProgramV2ClassesInput = {
  isFree?: InputMaybe<Scalars["Boolean"]>;
};

export type ProgramV2Edge = {
  __typename?: "ProgramV2Edge";
  /** The pointer reference to where the edge is in respect to the list. */
  cursor: Scalars["String"];
  /** The in progress program data node. */
  node: ProgramV2;
};

export type ProgramsHistoryConnection = {
  __typename?: "ProgramsHistoryConnection";
  /** The list of Steezy in progress program data edges. */
  edges: Array<ProgramV2Edge>;
  /** Pagination metadata. */
  pageInfo: PageInfo;
};

export type ProgramsHistoryData = {
  __typename?: "ProgramsHistoryData";
  /** Pagination connection */
  connection?: Maybe<ProgramsHistoryConnection>;
};

export enum ProgressFilter {
  All = "all",
  Completed = "completed",
  Incomplete = "incomplete",
}

export type ProviderInfo = {
  __typename?: "ProviderInfo";
  id: Scalars["String"];
  lookupKey?: Maybe<Scalars["String"]>;
  name: SubscriptionProvider;
};

export type Query = {
  __typename?: "Query";
  /** Fetches the entire graph in SDL format */
  _sdl: Scalars["String"];
  achievementById?: Maybe<Achievement>;
  /** Get comment by ID. */
  activityCommentById?: Maybe<ActivityComment>;
  /** Admin API Requires the admin role to use. */
  admin: Admin;
  /** Get all programs. Requires the admin role to use. */
  adminProgramGetList: Array<AdminProgram>;
  /** Get a single program by slug. Requires the admin role to use. */
  adminProgramGetOne?: Maybe<AdminProgram>;
  badgeById?: Maybe<Badge>;
  /** A list of badges earned by the user grouped by year. Requires the user role to use. */
  badgesByYear: Array<BadgeYearGroup>;
  /** A list of badges earned by the user. Requires the user role to use. */
  badgesGetByUsername: Array<UserBadge>;
  /** Get published categories. Requires the user role to use. */
  categoriesPublic: CategoryConnection;
  /** Get published category by slug. Requires the user role to use. */
  categoryBySlugPublic?: Maybe<ClassCategory>;
  /** Get published challenge by ID. Requires the user role to use. */
  challengeById?: Maybe<Challenge>;
  /**
   * Get filterable challenges. Requires the admin role to use.
   * @deprecated Use admin.challenges instead
   */
  challenges: ChallengeConnection;
  /** Get published challenges. Requires the user role to use. */
  challengesAvailable: ChallengeConnection;
  /** Get active challenges. Requires the user role to use. */
  challengesPromoted: Array<Challenge>;
  /** Check if a specific coupon code is applied to a subscription. Requires the user role to use. */
  checkSubscriptionCoupon: Scalars["Boolean"];
  /** Get estimated pricing for checkout. */
  checkoutEstimate?: Maybe<CheckoutEstimate>;
  /** Get class by ID. */
  classById: Class;
  /** Get published class video by ID. Requires the user role to use. */
  classVideoById: ClassVideo;
  /** Get filterable class videos. Requires the admin role to use. */
  classVideos: ClassVideoConnection;
  /** The current Community Guidelines version. Clients compare this to User.communityGuidelinesVersion to decide whether to gate UGC surfaces. Requires the user role to use. */
  communityGuidelinesCurrentVersion: Scalars["String"];
  /** Fetch all remote config parameters. Requires the user role to use. */
  configs: Config;
  /**
   * Featured studio classes. Requires the user role to use.
   * @deprecated Use getFeaturedClasses instead
   */
  featured: Array<FeaturedContent>;
  /**
   * Featured playlists. Requires the user role to use.
   * @deprecated Use getFeaturedPlaylists instead
   */
  featuredPlaylists: Array<PlaylistV2>;
  /** Get filterable flagged activities. Requires the admin role to use. */
  flaggedActivities: FlaggedActivityConnection;
  /** Get flagged activity by ID. Requires the admin role to use. */
  flaggedActivityById?: Maybe<FlaggedActivity>;
  /** Generates a Stripe Express Checkout payment intent for the requesting user. Requires the user role to use. */
  generateStripeExpressCheckoutPaymentIntent?: Maybe<StripePaymentIntent>;
  /** Generates a Stripe Express Checkout setup intent for the requesting user. Requires the user role to use. */
  generateStripeExpressCheckoutSetupIntent?: Maybe<StripePaymentIntent>;
  /** Generates a Stripe payment intent for the requesting user. Requires the user role to use. */
  generateStripePaymentIntent?: Maybe<StripePaymentIntent>;
  getAllAchievements: Array<Achievement>;
  getBadgesForAchievement: Array<Badge>;
  getCalendarData: GetCalendarDataOutput;
  /** Get a cancel survey by subscription ID Requires the user role to use. */
  getCancelSurveyBySubscriptionId: CancelSurvey;
  /** Given a list of category slugs, this query will fetch data related to a category. If no slugs are provided, the query will fetch all categories */
  getCategories: Array<Category>;
  /** Fetches class details and optionally a next program class given a reference ID */
  getClass: GetClassResponse;
  /** Fetches class details on its own given a class' reference ID */
  getClassById?: Maybe<Class>;
  getClassCompletedAchievementBadges: UserAchievement;
  getClassMinutesSpentAchievementBadges: UserAchievement;
  /** Fetches a paginated list of classes */
  getClasses: GetClassesConnection;
  /** Fetch presentational content by features */
  getContent?: Maybe<Content>;
  /** Get featured studio classes Requires the user role to use. */
  getFeaturedClasses: Array<FeaturedStudioClass>;
  /** Get featured playlists Requires the user role to use. */
  getFeaturedPlaylists: Array<FeaturedPlaylist>;
  getFreeDailyClasses: Array<Maybe<Class>>;
  /**
   * Fetch the users history class and program data in descending order of last viewed date.
   * @deprecated Use getHistoryDataV3
   */
  getHistoryData: SavedOrHistoryDataConnection;
  /**
   * Fetch the users history class and programV2 data in descending order of last viewed date.
   * @deprecated Use getHistoryDataV3
   */
  getHistoryDataV2: SavedOrHistoryDataConnectionV2;
  /** Fetch the users history class and programV2 data based on ordering params. */
  getHistoryDataV3: SavedOrHistoryDataConnectionV2;
  /** Fetches all programs in progress or return a default program */
  getInProgressPrograms: InProgressProgramData;
  /** Given an instructor slug, this query will fetch all related data for the specified instructor. */
  getInstructor: Instructor;
  /** Fetch the markup data for dance preferences. */
  getOnboardingData: OnboardingData;
  /** Fetches a playlist for the user by a specific date. The date should be a string with the format YYYY-MM-DD */
  getPlaylist?: Maybe<Playlist>;
  getPostCommentAchievementBadges: UserAchievement;
  getPostUploadAchievementBadges: UserAchievement;
  /** Fetches a program V2 */
  getProgramV2?: Maybe<ProgramV2>;
  /** Fetches a program V2 provided a class reference ID */
  getProgramV2WithRef?: Maybe<ProgramV2>;
  /**
   * Fetches a paginated list of programs
   * @deprecated Use searchProgramsV2
   */
  getPrograms: GetProgramsConnection;
  /** Fetches all programs in progress */
  getProgramsHistory: ProgramsHistoryData;
  getRecommendedClasses?: Maybe<RecommendedClassesConnection>;
  /**
   * Fetch the users saved class and program data in descending order of saved date.
   * @deprecated Use getSavedDataV2
   */
  getSavedData: SavedOrHistoryDataConnection;
  /** Fetch the users saved class and programV2 data in descending order of saved date. */
  getSavedDataV2: SavedOrHistoryDataConnectionV2;
  /** Fetch the users streak progress. */
  getStreakProgress: StreakProgress;
  getStyles: Array<Style>;
  /** Get published instructor by slug. Requires the user role to use. */
  instructorBySlugPublic?: Maybe<ClassInstructor>;
  /** Get published instructors. Requires the user role to use. */
  instructorsPublic: InstructorConnection;
  /** Get metadata for requesting user. Requires the user role to use. */
  me?: Maybe<User>;
  /** Recently published studio classes, newest first. Requires the user role to use. */
  newlyAddedClasses: Array<Class>;
  plans: Array<Plan>;
  /** Get playlist details. Requires the user role to use. */
  playlist: PlaylistV2;
  /** Get class by ID. Requires the user role to use. */
  playlistClassById: PlaylistClass;
  /** Get STEEZY curated playlists. Requires the user role to use. */
  playlistsSteezy: PlaylistV2Connection;
  /** @deprecated Use getProgramV2 */
  program?: Maybe<Program>;
  /** Studio classes 15 minutes or less, newest first. Requires the user role to use. */
  quickWinClasses: Array<Class>;
  schedule?: Maybe<Schedule>;
  /**
   * Algolia proxy query to search classes.
   * @deprecated Use getClasses
   */
  searchClasses: AlgoliaClassesConnection;
  /** Algolia proxy query to search instructors. */
  searchInstructors: AlgoliaInstructorsConnection;
  /**
   * Algolia proxy query to search programs.
   * @deprecated Use searchProgramsV2
   */
  searchPrograms: AlgoliaProgramsConnection;
  /** Fetches a paginated list of programs V2 */
  searchProgramsV2: SearchProgramsV2Connection;
  /** Search for users by name or username. Requires the user role to use. */
  searchUsers: UserConnection;
  /** Get styles. Requires the user role to use. */
  styles: Array<Tag>;
  /** Get available plans for switching based on user's current subscription */
  switchablePlans: Array<Plan>;
  /** Get all artists. Requires the admin role to use. */
  trackArtists: Array<AutocompleteValue>;
  /** Get track by ID. Requires the admin role to use. */
  trackById?: Maybe<Track>;
  /** Get all genres. Requires the admin role to use. */
  trackGenres: Array<AutocompleteValue>;
  /** Get filterable tracks. Requires the admin role to use. */
  tracks: TrackConnection;
  user?: Maybe<User>;
  /** Get user by email. Requires the admin role to use. */
  userByEmail?: Maybe<User>;
  /** Get user by ID. Requires the admin role to use. */
  userById?: Maybe<User>;
  /** Get user by uid. Requires the admin role to use. */
  userByUid?: Maybe<User>;
  /** Generate a username for a user. Requires the user role to use. */
  userGenerateUsername: UserUsername;
  /** Fetch user preference data. Requires the user role to use. */
  userPreferenceOptions: Array<UserPreferenceOption>;
  /** Fetch user profile data by username. Requires the user role to use. */
  userProfileGetByUsername: UserProfileWithVideos;
  /** Validate a user's parental controls pin. Requires the user role to use. */
  userValidatePin: Scalars["Boolean"];
  /** Get filterable users. Requires the admin role to use. */
  users: UserConnection;
  /** Get UGC video metadata by ID. Requires the admin role to use. */
  videoUploadById: VideoUpload;
  /** Get encoded and approved UGC video by ID. */
  videoUploadByIdPublic: VideoUpload;
  /** Get filterable UGC videos. Requires the admin role to use. */
  videoUploads: VideoUploadConnection;
  /** Get filterable published UGC videos. Requires the user role to use. */
  videoUploadsPublished: VideoUploadConnection;
};

export type QueryAchievementByIdArgs = {
  id: Scalars["String"];
};

export type QueryActivityCommentByIdArgs = {
  id: Scalars["String"];
};

export type QueryAdminProgramGetOneArgs = {
  slug: Scalars["String"];
};

export type QueryBadgeByIdArgs = {
  id: Scalars["String"];
};

export type QueryBadgesByYearArgs = {
  username: Scalars["String"];
};

export type QueryBadgesGetByUsernameArgs = {
  username: Scalars["String"];
};

export type QueryCategoriesPublicArgs = {
  filter?: InputMaybe<CategoryFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type QueryCategoryBySlugPublicArgs = {
  slug: Scalars["String"];
};

export type QueryChallengeByIdArgs = {
  id: Scalars["String"];
};

export type QueryChallengesArgs = {
  filter?: InputMaybe<ChallengeFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type QueryChallengesAvailableArgs = {
  pagination: ConnectionArgs;
};

export type QueryCheckSubscriptionCouponArgs = {
  input: CheckSubscriptionCouponInput;
};

export type QueryCheckoutEstimateArgs = {
  input: CheckoutEstimateInput;
};

export type QueryClassByIdArgs = {
  id: Scalars["String"];
};

export type QueryClassVideoByIdArgs = {
  videoId: Scalars["String"];
};

export type QueryClassVideosArgs = {
  filter?: InputMaybe<ClassVideoFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type QueryFlaggedActivitiesArgs = {
  filter?: InputMaybe<FlaggedActivityFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type QueryFlaggedActivityByIdArgs = {
  id: Scalars["String"];
};

export type QueryGenerateStripeExpressCheckoutPaymentIntentArgs = {
  input: ExpressCheckoutPaymentIntentGenerateInput;
};

export type QueryGenerateStripePaymentIntentArgs = {
  input: StripePaymentInput;
};

export type QueryGetBadgesForAchievementArgs = {
  achievementId: Scalars["String"];
};

export type QueryGetCalendarDataArgs = {
  input?: InputMaybe<GetCalendarDataInput>;
};

export type QueryGetCancelSurveyBySubscriptionIdArgs = {
  subscriptionId: Scalars["String"];
};

export type QueryGetCategoriesArgs = {
  input: GetCategoriesInput;
};

export type QueryGetClassArgs = {
  input: GetClassInput;
};

export type QueryGetClassByIdArgs = {
  input: Scalars["ID"];
};

export type QueryGetClassesArgs = {
  input?: InputMaybe<GetClassesInput>;
};

export type QueryGetHistoryDataArgs = {
  input?: InputMaybe<GetPaginatedInput>;
};

export type QueryGetHistoryDataV2Args = {
  input?: InputMaybe<GetPaginatedInput>;
};

export type QueryGetHistoryDataV3Args = {
  input?: InputMaybe<HistoryV3Input>;
};

export type QueryGetInProgressProgramsArgs = {
  input: GetInProgressProgramsInput;
};

export type QueryGetInstructorArgs = {
  input: GetInstructorInput;
};

export type QueryGetPlaylistArgs = {
  date: Scalars["String"];
};

export type QueryGetProgramV2Args = {
  slug: Scalars["String"];
};

export type QueryGetProgramV2WithRefArgs = {
  input: GetProgramV2WithRefInput;
};

export type QueryGetProgramsArgs = {
  input?: InputMaybe<GetProgramsInput>;
};

export type QueryGetProgramsHistoryArgs = {
  input: GetProgramsHistoryInput;
};

export type QueryGetRecommendedClassesArgs = {
  input?: InputMaybe<GetRecommendedClassesInput>;
};

export type QueryGetSavedDataArgs = {
  input?: InputMaybe<GetPaginatedInput>;
};

export type QueryGetSavedDataV2Args = {
  input?: InputMaybe<GetPaginatedInput>;
};

export type QueryGetStreakProgressArgs = {
  input?: InputMaybe<GetStreakProgressInput>;
};

export type QueryInstructorBySlugPublicArgs = {
  slug: Scalars["String"];
};

export type QueryInstructorsPublicArgs = {
  filter?: InputMaybe<InstructorFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type QueryMeArgs = {
  input?: InputMaybe<UserMeInput>;
};

export type QueryNewlyAddedClassesArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
};

export type QueryPlansArgs = {
  input: PlansInput;
};

export type QueryPlaylistArgs = {
  playlistId: Scalars["String"];
};

export type QueryPlaylistClassByIdArgs = {
  id: Scalars["String"];
};

export type QueryPlaylistsSteezyArgs = {
  pagination: ConnectionArgs;
};

export type QueryProgramArgs = {
  slug: Scalars["String"];
};

export type QueryQuickWinClassesArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
};

export type QueryScheduleArgs = {
  date?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
};

export type QuerySearchClassesArgs = {
  input: AlgoliaSearchInput;
};

export type QuerySearchInstructorsArgs = {
  input: AlgoliaSearchInput;
};

export type QuerySearchProgramsArgs = {
  input: AlgoliaSearchInput;
};

export type QuerySearchProgramsV2Args = {
  input: SearchProgramsV2Input;
};

export type QuerySearchUsersArgs = {
  filter?: InputMaybe<UserSearchFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type QueryTrackByIdArgs = {
  id: Scalars["String"];
};

export type QueryTracksArgs = {
  filter?: InputMaybe<TrackFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type QueryUserArgs = {
  uid?: InputMaybe<Scalars["ID"]>;
};

export type QueryUserByEmailArgs = {
  email: Scalars["String"];
};

export type QueryUserByIdArgs = {
  id: Scalars["String"];
};

export type QueryUserByUidArgs = {
  uid: Scalars["String"];
};

export type QueryUserGenerateUsernameArgs = {
  input: UserGenerateUsernameInput;
};

export type QueryUserPreferenceOptionsArgs = {
  type: UserPreferenceType;
};

export type QueryUserProfileGetByUsernameArgs = {
  input: UserProfileInput;
};

export type QueryUserValidatePinArgs = {
  input: UserValidatePinInput;
};

export type QueryUsersArgs = {
  filter?: InputMaybe<UserFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type QueryVideoUploadByIdArgs = {
  input: VideoUploadByIdInput;
};

export type QueryVideoUploadByIdPublicArgs = {
  input: VideoUploadByIdInput;
};

export type QueryVideoUploadsArgs = {
  filter?: InputMaybe<VideoUploadsFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type QueryVideoUploadsPublishedArgs = {
  filter?: InputMaybe<VideoUploadsPublishedFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type QueuePartyMemberOutput = {
  __typename?: "QueuePartyMemberOutput";
  accessToken?: Maybe<Scalars["String"]>;
  classId: Scalars["Int"];
  expiresAt: Scalars["String"];
  id: Scalars["String"];
  status: Scalars["String"];
};

export type RateClassInput = {
  classId: Scalars["Int"];
  /** Optional comment elaborating why the user gave a certain rating */
  comment?: InputMaybe<Scalars["String"]>;
  /** A rating value between 1 and 5 for a class. */
  rating: Scalars["Int"];
};

export type RateClassOutput = {
  __typename?: "RateClassOutput";
  classId: Scalars["String"];
  /** Optional comment elaborating why the user gave a certain rating */
  comment?: Maybe<Scalars["String"]>;
  /** The date the rating was created in ISO8601 */
  createdAt: Scalars["String"];
  /** A rating value between 1 and 5 for a class. */
  rating: Scalars["Int"];
};

export type ReasonOption = {
  __typename?: "ReasonOption";
  /** The description of a dance reason option. */
  description?: Maybe<Scalars["String"]>;
  /** The goal of a dance reason option. */
  goal?: Maybe<Scalars["String"]>;
  /** The label of a dance reason option. */
  label?: Maybe<Scalars["String"]>;
  /** A preview image URL for each dance reason option. */
  previewImgURL?: Maybe<Scalars["String"]>;
  /** The slug of a dance reason option. */
  slug: Scalars["ID"];
  /** The experiment variant of the user. */
  variant?: Maybe<Scalars["String"]>;
};

export type RecommendedClass = {
  __typename?: "RecommendedClass";
  duration?: Maybe<Scalars["String"]>;
  duration_in_seconds?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["String"]>;
  instructorName?: Maybe<Scalars["String"]>;
  recommendationIndex?: Maybe<Scalars["Int"]>;
  slug?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
};

export type RecommendedClassesConnection = {
  __typename?: "RecommendedClassesConnection";
  edges: Array<RecommendedClassesEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type RecommendedClassesEdge = {
  __typename?: "RecommendedClassesEdge";
  cursor: Scalars["String"];
  node: RecommendedClass;
};

export type RemovePlanFromCountryInput = {
  countryId?: InputMaybe<Scalars["String"]>;
  countryIsoCode?: InputMaybe<Scalars["String"]>;
  planId?: InputMaybe<Scalars["String"]>;
  providerId?: InputMaybe<Scalars["String"]>;
  providerName?: InputMaybe<SubscriptionProvider>;
};

export type RemoveTakenClassInput = {
  classId: Scalars["Int"];
  date: Scalars["String"];
};

export type RemoveTakenClassInputV2 = {
  classIdentifier: ClassIdentifier;
  date: Scalars["String"];
};

export type Role = {
  __typename?: "Role";
  createdAt: Scalars["DateTime"];
  id: Scalars["ID"];
  name: Scalars["String"];
  updatedAt: Scalars["DateTime"];
};

export type SavedOrHistoryDataConnection = {
  __typename?: "SavedOrHistoryDataConnection";
  /** The list of Steezy saved or history data edges. */
  edges: Array<SavedOrHistoryEdge>;
  /** Pagination metadata. */
  pageInfo: PageInfo;
};

export type SavedOrHistoryDataConnectionV2 = {
  __typename?: "SavedOrHistoryDataConnectionV2";
  /** The list of Steezy saved or history data edges. */
  edges: Array<ClassProgramV2Edge>;
  /** Pagination metadata. */
  pageInfo: PageInfo;
};

export type SavedOrHistoryEdge = {
  __typename?: "SavedOrHistoryEdge";
  /** The pointer reference to where the edge is in respect to the list. */
  cursor: Scalars["String"];
  /** The saved or history data node. A union type that can be either a Class or Program type. */
  node: ClassOrProgram;
};

export type Schedule = {
  __typename?: "Schedule";
  date?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  playlists?: Maybe<Array<Maybe<Playlist>>>;
  progress?: Maybe<ScheduleProgress>;
};

export type ScheduleProgress = {
  __typename?: "ScheduleProgress";
  completed?: Maybe<Scalars["String"]>;
  seen_completed_modal?: Maybe<Scalars["String"]>;
  seen_started_modal?: Maybe<Scalars["String"]>;
  started?: Maybe<Scalars["String"]>;
};

export type SearchProgramsV2Connection = {
  __typename?: "SearchProgramsV2Connection";
  /** Pagination metadata. */
  pageInfo: PaginationInfo;
  /** The list of matched programs */
  programs: Array<ProgramV2>;
};

export type SearchProgramsV2Input = {
  /** Filter the query with numeric, facet and/or tag filters. */
  filters?: InputMaybe<Scalars["String"]>;
  /** If set to true, all returned programs must be free, and all their associated class data will only be classes accessible to free users. */
  freeOnly?: InputMaybe<Scalars["Boolean"]>;
  /** If set to true, all returned programs will be programs that the user has started. */
  inProgressOnly?: InputMaybe<Scalars["Boolean"]>;
  /** Defines the desired pagination state for the results. */
  pagination: PaginationBody;
  /** The query used to search. Accepts every character, and every character entered will be used in the search. An empty query can be used to fetch all records. */
  query: Scalars["String"];
  /** Controls the way results are sorted. Default value for 'orderBy' is 'publishDate'. Default value for 'orderDirection' is 'desc'. */
  sort?: InputMaybe<SortBody>;
};

export type SecondsSpentPerDay = {
  __typename?: "SecondsSpentPerDay";
  date: Scalars["String"];
  seconds: Scalars["Int"];
};

export type SectionCuepoint = {
  __typename?: "SectionCuepoint";
  name?: Maybe<Scalars["String"]>;
  time?: Maybe<Scalars["String"]>;
  timeSec?: Maybe<Scalars["Int"]>;
};

export type SectionCuepointInput = {
  name: Scalars["String"];
  timeSec: Scalars["Int"];
};

export type SetAccountTypePreferenceInput = {
  /** The slug of a account type option. */
  slug: Scalars["ID"];
};

export type SetClassDurationPreferenceInput = {
  /** The slug of a class duration option. */
  slug: Scalars["ID"];
};

export type SetDanceCadenceInput = {
  daysPerWeek: Scalars["String"];
  /** Days of the week (e.g. monday) */
  slugs: Array<Scalars["String"]>;
};

export type SetDanceEnergyInput = {
  slug: Scalars["String"];
};

export type SetDanceFrequencyInput = {
  slug: Scalars["String"];
};

export type SetDanceGoalsInput = {
  slugs: Array<Scalars["String"]>;
};

export type SetDanceHabitInput = {
  slug: Scalars["String"];
};

export type SetDanceLevelInput = {
  slug: Scalars["String"];
};

export type SetDanceLevelPreferenceInput = {
  /** The slug of a dance level option. */
  slug: Scalars["ID"];
};

export type SetDanceLocationsInput = {
  slugs: Array<Scalars["String"]>;
};

export type SetDanceReasonPreferenceInput = {
  /** The slug of a dance reason option. */
  slug: Scalars["ID"];
};

export type SetExperimentInput = {
  experimentId: Scalars["ID"];
};

export type SetExperimentOutput = {
  __typename?: "SetExperimentOutput";
  experimentId: Scalars["String"];
  variant: Scalars["String"];
};

export type SetFamilyGoalPreferenceInput = {
  /** The slug of a family goal option. */
  slug: Scalars["ID"];
};

export type SetHdyhauSurveyResponseInput = {
  slugs: Array<Scalars["String"]>;
};

export type SetUserAgeInput = {
  slug: Scalars["String"];
};

export type SetUsernameInput = {
  /** The new username the user wants to update to */
  newUsername: Scalars["String"];
};

export type SetUsersTimezoneInput = {
  zoneName: Scalars["String"];
};

export type SocialMediaHandle = {
  __typename?: "SocialMediaHandle";
  /** A string representing the social media platform. */
  platform: Scalars["String"];
  /** A URL linking to the social media platform. */
  url: Scalars["String"];
};

export type Song = {
  __typename?: "Song";
  artist?: Maybe<Scalars["String"]>;
  isExplicit?: Maybe<Scalars["Boolean"]>;
  title?: Maybe<Scalars["String"]>;
};

export type SortBody = {
  /** The field used when ordering classes. */
  orderBy?: InputMaybe<Scalars["String"]>;
  /** Either 'asc' or 'desc'. The direction by which to sort the results when filtered on the 'orderBy' field. */
  orderDirection?: InputMaybe<Scalars["String"]>;
};

export type SortBodyV2 = {
  /** Either 'all', 'incomplete', or 'completed'. Filters based on progress. */
  filterBy?: InputMaybe<ProgressFilter>;
  /** The field used when ordering classes. */
  orderBy?: InputMaybe<SortBy>;
  /** Either 'asc' or 'desc'. The direction by which to sort the results when filtered on the 'orderBy' field. */
  orderDirection?: InputMaybe<SortOrder>;
};

export enum SortBy {
  DateLastViewed = "dateLastViewed",
  DateSaved = "dateSaved",
}

export enum SortOrder {
  Asc = "asc",
  Desc = "desc",
}

export type StreakProgress = {
  __typename?: "StreakProgress";
  dailyStreaks?: Maybe<Array<Maybe<DailyStreak>>>;
  weeklyStreakCount?: Maybe<Scalars["Int"]>;
  weeklyStreakGoal: Scalars["Int"];
};

export type StripeCollectPaymentInput = {
  customerId?: InputMaybe<Scalars["String"]>;
  invoiceId: Scalars["String"];
  paymentMethodId: Scalars["String"];
};

export type StripePaymentInput = {
  amountInCents: Scalars["Float"];
};

export type StripePaymentIntent = {
  __typename?: "StripePaymentIntent";
  clientSecret: Scalars["String"];
  id: Scalars["String"];
};

export type StudioClass = {
  __typename?: "StudioClass";
  accessType?: Maybe<AccessType>;
  actionCuepoints?: Maybe<Array<ActionCuepoint>>;
  classId: Scalars["Float"];
  createdAt: Scalars["DateTime"];
  externalPreviewUrl?: Maybe<Scalars["String"]>;
  /** @deprecated Use accessType */
  free: Scalars["Boolean"];
  hidden: Scalars["Boolean"];
  id: Scalars["ID"];
  instructor?: Maybe<ClassInstructor>;
  /** True if class has licensing rights to all its tracks */
  isClassFullyLicensed: Scalars["Boolean"];
  /** True if this class contains an explicit track. Requires the user role to use. */
  isExplicit: Scalars["Boolean"];
  isFamilyFriendly: Scalars["Boolean"];
  /** @deprecated Use classVideoType on video instead. */
  isSingleView: Scalars["Boolean"];
  level?: Maybe<Scalars["String"]>;
  mutedCuepoints?: Maybe<Array<MutedCuepoint>>;
  /** Requires the user role to use. */
  previewVideo: ClassVideo;
  publishDate?: Maybe<Scalars["DateTime"]>;
  sections?: Maybe<Array<StudioClassSectionEntity>>;
  /** @deprecated Use isClassFullyLicensed resolver */
  shouldBeMuted: Scalars["Boolean"];
  slug: Scalars["String"];
  /** @deprecated Use StyleV2. */
  style?: Maybe<Scalars["String"]>;
  /** Requires the user role to use. */
  styleV2?: Maybe<ClassStyle>;
  tags: Array<Tag>;
  thumbnailImageId?: Maybe<Scalars["String"]>;
  /** Full thumbnail image url. Requires the user role to use. */
  thumbnailImageUrl?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
  type?: Maybe<Scalars["String"]>;
  updatedAt: Scalars["DateTime"];
  /** User progress for class. Requires the user role to use. */
  userProgress: UserClassProgress;
  /** Requires the user role to use. */
  video: ClassVideo;
};

/** Studio class asset types */
export enum StudioClassAssetType {
  Thumbnail = "thumbnail",
}

export type StudioClassConnection = {
  __typename?: "StudioClassConnection";
  edges: Array<StudioClassEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type StudioClassCreateInput = {
  classId: Scalars["Float"];
  title: Scalars["String"];
};

export type StudioClassEdge = {
  __typename?: "StudioClassEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: StudioClass;
};

export type StudioClassSectionEntity = {
  __typename?: "StudioClassSectionEntity";
  cuepoints?: Maybe<Array<SectionCuepoint>>;
  name: Scalars["String"];
};

export type StudioClassSectionInput = {
  cuepoints: Array<SectionCuepointInput>;
  name: Scalars["String"];
};

export type StudioClassTrack = {
  __typename?: "StudioClassTrack";
  id: Scalars["ID"];
  startsAt: Scalars["Float"];
  studioClass: StudioClass;
  track: Track;
};

export type StudioClassUpdateInput = {
  accessType?: InputMaybe<AccessType>;
  actionCuepoints?: InputMaybe<Array<ActionCuepointInput>>;
  categoryIds?: InputMaybe<Array<Scalars["String"]>>;
  classId: Scalars["String"];
  externalPreviewUrl?: InputMaybe<Scalars["String"]>;
  free?: InputMaybe<Scalars["Boolean"]>;
  hidden?: InputMaybe<Scalars["Boolean"]>;
  instructorId?: InputMaybe<Scalars["String"]>;
  isFamilyFriendly?: InputMaybe<Scalars["Boolean"]>;
  level?: InputMaybe<Scalars["String"]>;
  mutedCuepoints?: InputMaybe<Array<MutedCuepointInput>>;
  previewVideoId?: InputMaybe<Scalars["String"]>;
  publishDate?: InputMaybe<Scalars["DateTime"]>;
  sections?: InputMaybe<Array<StudioClassSectionInput>>;
  shouldBeMuted?: InputMaybe<Scalars["Boolean"]>;
  slug?: InputMaybe<Scalars["String"]>;
  style?: InputMaybe<Scalars["String"]>;
  tagIds?: InputMaybe<Array<Scalars["String"]>>;
  thumbnailImageId?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
  videoId?: InputMaybe<Scalars["String"]>;
};

export type Style = {
  __typename?: "Style";
  isFollowing?: Maybe<Scalars["Boolean"]>;
  name: Scalars["String"];
  slug: Scalars["String"];
};

export type SubmitCancelationFeedbackInput = {
  feedbackText: Scalars["String"];
};

export type Subscription = {
  __typename?: "Subscription";
  cancelationTime?: Maybe<Scalars["Float"]>;
  createdAt: Scalars["DateTime"];
  currentTermEnd?: Maybe<Scalars["Float"]>;
  id: Scalars["ID"];
  invoiceDue?: Maybe<Invoice>;
  invoiceEstimate?: Maybe<SubscriptionInvoiceEstimate>;
  isActive: Scalars["Boolean"];
  isCancelable: Scalars["Boolean"];
  isPastDue: Scalars["Boolean"];
  isPauseScheduled: Scalars["Boolean"];
  isReactivatable: Scalars["Boolean"];
  isReactivatableV2: Scalars["Boolean"];
  nextBillingAt?: Maybe<Scalars["Float"]>;
  pauseTime?: Maybe<Scalars["Float"]>;
  plan: Plan;
  provider: ProviderInfo;
  resumeTime?: Maybe<Scalars["Float"]>;
  status: SubscriptionStatus;
  trialEndTime?: Maybe<Scalars["Float"]>;
  updatedAt: Scalars["DateTime"];
  user: User;
};

export type SubscriptionCancelInput = {
  cancelNow?: InputMaybe<Scalars["Boolean"]>;
  cancelReason?: InputMaybe<Scalars["String"]>;
  subscriptionId: Scalars["String"];
};

export type SubscriptionCreateForCustomerInput = {
  couponIds?: InputMaybe<Array<Scalars["String"]>>;
  idempotencyKey?: InputMaybe<Scalars["String"]>;
  ipInfo?: InputMaybe<IpInfoInput>;
  planInfo: PlanInfoInput;
};

export type SubscriptionCreateInput = {
  couponIds?: InputMaybe<Array<Scalars["String"]>>;
  gateway: GatewayInput;
  idempotencyKey?: InputMaybe<Scalars["String"]>;
  ipInfo?: InputMaybe<IpInfoInput>;
  paymentMethodType: PaymentMethodType;
  planInfo: PlanInfoInput;
  trialEndTime?: InputMaybe<Scalars["Timestamp"]>;
  trialOverrideTime?: InputMaybe<Scalars["Timestamp"]>;
};

export type SubscriptionExtendTrialInput = {
  subscriptionId: Scalars["String"];
  trialEndTime: Scalars["DateTime"];
};

export type SubscriptionInvoiceEstimate = {
  __typename?: "SubscriptionInvoiceEstimate";
  amountDue?: Maybe<Scalars["Float"]>;
  creditsApplied?: Maybe<Scalars["Float"]>;
  subTotal?: Maybe<Scalars["Float"]>;
  total?: Maybe<Scalars["Float"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type SubscriptionPauseInput = {
  resumeTime: Scalars["DateTime"];
  subscriptionId: Scalars["String"];
};

export enum SubscriptionProvider {
  Braintree = "braintree",
  Chargebee = "chargebee",
  Revenuecat = "revenuecat",
  Steezy = "steezy",
  Stripe = "stripe",
}

export type SubscriptionReactivateInput = {
  subscriptionId: Scalars["String"];
};

export type SubscriptionReactivateUsingCouponInput = {
  couponId: Scalars["String"];
  subscriptionId: Scalars["String"];
};

export type SubscriptionRemoveScheduledChangesInput = {
  subscriptionId: Scalars["String"];
};

export type SubscriptionResumeInput = {
  resumeTime?: InputMaybe<Scalars["DateTime"]>;
  shouldResumeNow?: InputMaybe<Scalars["Boolean"]>;
  subscriptionId: Scalars["String"];
};

/** The subscription's current status */
export enum SubscriptionStatus {
  Active = "active",
  Canceled = "canceled",
  CanceledDuringPending = "canceled_during_pending",
  Future = "future",
  FutureCanceled = "future_canceled",
  InTrial = "in_trial",
  NonRenewing = "non_renewing",
  Paused = "paused",
  Pending = "pending",
}

export type SubscriptionSwitchInput = {
  planId: Scalars["String"];
  subscriptionId: Scalars["String"];
};

export type SubscriptionUpgradeInput = {
  planId: Scalars["String"];
  subscriptionId: Scalars["String"];
};

export type SuccessPayload = {
  __typename?: "SuccessPayload";
  success?: Maybe<Scalars["Boolean"]>;
};

export type Tag = {
  __typename?: "Tag";
  createdAt: Scalars["DateTime"];
  displayIndex?: Maybe<Scalars["Int"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
  previewVideoId?: Maybe<Scalars["String"]>;
  previewVideoUrl?: Maybe<Scalars["String"]>;
  slug?: Maybe<Scalars["String"]>;
  thumbnailImageId?: Maybe<Scalars["String"]>;
  thumbnailImageUrl?: Maybe<Scalars["String"]>;
  type: Scalars["String"];
  updatedAt: Scalars["DateTime"];
};

export type TagConnection = {
  __typename?: "TagConnection";
  edges: Array<TagEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type TagCreateInput = {
  displayIndex?: InputMaybe<Scalars["Int"]>;
  name: Scalars["String"];
  previewVideoId?: InputMaybe<Scalars["String"]>;
  slug?: InputMaybe<Scalars["String"]>;
  thumbnailImageId?: InputMaybe<Scalars["String"]>;
  type: Scalars["String"];
};

export type TagEdge = {
  __typename?: "TagEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: Tag;
};

export type TagFilterInput = {
  displayIndex?: InputMaybe<Scalars["Float"]>;
  name?: InputMaybe<Scalars["String"]>;
  slug?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
};

export type TagUpdateInput = {
  displayIndex?: InputMaybe<Scalars["Int"]>;
  id: Scalars["String"];
  name: Scalars["String"];
  previewVideoId?: InputMaybe<Scalars["String"]>;
  slug: Scalars["String"];
  thumbnailImageId?: InputMaybe<Scalars["String"]>;
  type: Scalars["String"];
};

export type Time = {
  __typename?: "Time";
  hour?: Maybe<Scalars["Int"]>;
  minute?: Maybe<Scalars["Int"]>;
  second?: Maybe<Scalars["Int"]>;
};

export type TimeV2 = {
  __typename?: "TimeV2";
  hour: Scalars["Int"];
  minute: Scalars["Int"];
  second: Scalars["Int"];
};

export type ToggleClassCompleteInput = {
  /** True if the program class should be toggled completed */
  isComplete: Scalars["Boolean"];
  /** The program class reference ID */
  programClassRefId: Scalars["String"];
};

export type ToggleNotificationsInput = {
  isEnabled: Scalars["Boolean"];
};

export type ToggleNotificationsOutput = {
  __typename?: "ToggleNotificationsOutput";
  isEnabled: Scalars["Boolean"];
};

export type ToggleSaveClassInput = {
  /** The class ID */
  classId: Scalars["String"];
  /** The program class reference ID */
  programClassRefId?: InputMaybe<Scalars["String"]>;
  /** True if the operation intends to save the class */
  willSave: Scalars["Boolean"];
};

export type ToggleSaveProgramInput = {
  /** The program slug */
  programSlug: Scalars["String"];
  /** True if the operation intends to save the program */
  willSave: Scalars["Boolean"];
};

export type Track = {
  __typename?: "Track";
  albumName?: Maybe<Scalars["String"]>;
  appleMusic?: Maybe<Scalars["String"]>;
  artists: Array<Scalars["String"]>;
  copyright?: Maybe<Scalars["String"]>;
  createdAt: Scalars["DateTime"];
  genre: Array<Scalars["String"]>;
  id: Scalars["ID"];
  image?: Maybe<Scalars["String"]>;
  isExplicit: Scalars["Boolean"];
  isLicensed: Scalars["Boolean"];
  isrc: Scalars["String"];
  label?: Maybe<Scalars["String"]>;
  releaseDate?: Maybe<Scalars["String"]>;
  songId?: Maybe<Scalars["String"]>;
  soundcloud?: Maybe<Scalars["String"]>;
  source: TrackSource;
  spotify?: Maybe<Scalars["String"]>;
  tikTokSound?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
  trackId?: Maybe<Scalars["String"]>;
  updatedAt: Scalars["DateTime"];
  youtube?: Maybe<Scalars["String"]>;
};

export type TrackConnection = {
  __typename?: "TrackConnection";
  edges: Array<TrackEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type TrackEdge = {
  __typename?: "TrackEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: Track;
};

export type TrackFilterInput = {
  artist?: InputMaybe<Scalars["String"]>;
  classId?: InputMaybe<Scalars["String"]>;
  classNum?: InputMaybe<Scalars["String"]>;
  genre?: InputMaybe<Scalars["String"]>;
  isExplicit?: InputMaybe<Scalars["Boolean"]>;
  isLicensed?: InputMaybe<Scalars["Boolean"]>;
  isrc?: InputMaybe<Scalars["String"]>;
  label?: InputMaybe<Scalars["String"]>;
  songId?: InputMaybe<Scalars["String"]>;
  source?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  trackId?: InputMaybe<Scalars["String"]>;
};

export type TrackLicenseUpdateInput = {
  isLicensed: Scalars["Boolean"];
  isrc: Scalars["String"];
};

export type TrackLogPlayInput = {
  countryCode: Scalars["String"];
  trackId: Scalars["String"];
};

/** The track's info source */
export enum TrackSource {
  Manual = "manual",
  TunedGlobal = "tuned_global",
}

export type TrackUpsertInput = {
  albumName?: InputMaybe<Scalars["String"]>;
  appleMusic?: InputMaybe<Scalars["String"]>;
  artists?: InputMaybe<Array<Scalars["String"]>>;
  copyright?: InputMaybe<Scalars["String"]>;
  genre?: InputMaybe<Array<Scalars["String"]>>;
  image?: InputMaybe<Scalars["String"]>;
  isExplicit?: InputMaybe<Scalars["Boolean"]>;
  isLicensed?: InputMaybe<Scalars["Boolean"]>;
  isrc?: InputMaybe<Scalars["String"]>;
  label?: InputMaybe<Scalars["String"]>;
  releaseDate?: InputMaybe<Scalars["String"]>;
  songId?: InputMaybe<Scalars["String"]>;
  soundcloud?: InputMaybe<Scalars["String"]>;
  source: TrackSource;
  spotify?: InputMaybe<Scalars["String"]>;
  tikTokSound?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  youtube?: InputMaybe<Scalars["String"]>;
};

export type UpdateCountryInput = {
  name: Scalars["String"];
};

export type UpdatePlanSettingsInput = {
  /** The access type for the plan */
  accessType?: InputMaybe<AccessType>;
  /** Whether the plan should be displayed */
  isDisplayed?: InputMaybe<Scalars["Boolean"]>;
};

export type UploadPart = {
  __typename?: "UploadPart";
  partNumber: Scalars["Int"];
  url: Scalars["String"];
};

export type User = {
  __typename?: "User";
  badges: Array<UserBadge>;
  bannedAt?: Maybe<Scalars["DateTime"]>;
  bio?: Maybe<Scalars["String"]>;
  birthDate?: Maybe<Scalars["DateTime"]>;
  /** PRIVATE - Users the requester has blocked. Only queryable on `me` — returns empty connection for any other root user. Requires the user role to use. */
  blockedUsers: UserConnection;
  challenges: Array<ChallengeParticipant>;
  communityGuidelinesAcceptedAt?: Maybe<Scalars["DateTime"]>;
  communityGuidelinesVersion?: Maybe<Scalars["String"]>;
  createdAt: Scalars["DateTime"];
  dancePreferences?: Maybe<DancePreferences>;
  email: Scalars["String"];
  hasCommunityAccess: Scalars["Boolean"];
  hasExtendedTrial: Scalars["Boolean"];
  /** PRIVATE - Indicates if the user has any unread notifications. Only accessible to the requesting user. Requires the PRIVATE_FIELD role to use. */
  hasNewNotifications: Scalars["Boolean"];
  hasTrialed: Scalars["Boolean"];
  id: Scalars["ID"];
  instructor?: Maybe<ClassInstructor>;
  isActive: Scalars["Boolean"];
  /** Get the username for the requesting user. Requires the user role to use. */
  isFirebaseUsername: Scalars["Boolean"];
  /** PRIVATE - Total number of class unlocks earned by this user (including used ones). Only accessible to the requesting user. Requires the PRIVATE_FIELD role to use. */
  lifetimeClassUnlocks: Scalars["Int"];
  /** PRIVATE - Total credit cents earned by this user through invites and rewards. Only accessible to the requesting user. Requires the PRIVATE_FIELD role to use. */
  lifetimeCreditCents: Scalars["Int"];
  links?: Maybe<Array<UserProfileLink>>;
  /** PRIVATE - Playlists created by this user. Only accessible to the requesting user. Requires the PRIVATE_FIELD role to use. */
  myPlaylists: PlaylistV2Connection;
  name?: Maybe<Scalars["String"]>;
  /** PRIVATE - User's notification preferences. Only accessible to the requesting user. Requires the PRIVATE_FIELD role to use. */
  notificationPreferences: Array<NotificationPreference>;
  /** PRIVATE - Paginated list of notifications for this user. Only accessible to the requesting user. Requires the PRIVATE_FIELD role to use. */
  notifications: NotificationConnection;
  parentalControls: ParentalControls;
  /** PRIVATE - List of pending (not yet rewarded) invites sent by this user. Accessible to requesting user and admins. Requires the PRIVATE_FIELD role to use. */
  pendingInvites: Array<Invite>;
  /** PRIVATE - Personalized playlist recommendations for this user. Only accessible to the requesting user. Requires the PRIVATE_FIELD role to use. */
  personalizedPlaylist?: Maybe<Array<Class>>;
  photoURL?: Maybe<Scalars["String"]>;
  preferred?: Maybe<PreferredContent>;
  primaryPaymentSource?: Maybe<PaymentSource>;
  primarySubscription?: Maybe<Subscription>;
  progress?: Maybe<UserProgress>;
  /** PRIVATE - User's unique referral link for inviting others. Only accessible to the requesting user. Requires the PRIVATE_FIELD role to use. */
  referralUrl: Scalars["String"];
  remainingClassUnlocks: Scalars["Int"];
  remainingCreditCents: Scalars["Int"];
  /** PRIVATE - List of successfully rewarded invites sent by this user. Accessible to requesting user and admins. Requires the PRIVATE_FIELD role to use. */
  rewardedInvites: Array<Invite>;
  roles: Array<Role>;
  /** PRIVATE - Playlists saved by this user. Only accessible to the requesting user. Requires the PRIVATE_FIELD role to use. */
  savedPlaylists: PlaylistV2Connection;
  /** PRIVATE - Information about pending subscription changes. Only accessible to the requesting user. Requires the PRIVATE_FIELD role to use. */
  scheduledSubscriptionChange?: Maybe<Subscription>;
  streakProgress?: Maybe<StreakProgress>;
  /** PUBLIC - Total number of likes received on this user's videos. Accessible to all authenticated users. Requires the user role to use. */
  totalLikesCount: Scalars["Int"];
  uid: Scalars["String"];
  /** PRIVATE - List of classes unlocked by this user. Accessible to requesting user and admins. Requires the PRIVATE_FIELD role to use. */
  unlockedClasses: Array<Maybe<Class>>;
  updatedAt: Scalars["DateTime"];
  /** PUBLIC - Paginated list of video uploads submitted by this user. Accessible to all authenticated users. Requires the user role to use. */
  uploadedVideos?: Maybe<VideoUploadConnection>;
  /** Get the username for the requesting user. Requires the user role to use. */
  username: Scalars["String"];
  /** PRIVATE - User's weekly activity statistics. Only accessible to the requesting user. Requires the PRIVATE_FIELD role to use. */
  weeklyStats: UserWeeklyStats;
  /** PRIVATE - User's yearly activity statistics and achievements. Only accessible to the requesting user. Requires the PRIVATE_FIELD role to use. */
  yearlyStats: UserYearlyStats;
};

export type UserBlockedUsersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Float"]>;
  last?: InputMaybe<Scalars["Float"]>;
};

export type UserMyPlaylistsArgs = {
  pagination: ConnectionArgs;
};

export type UserNotificationsArgs = {
  pagination: ConnectionArgs;
};

export type UserSavedPlaylistsArgs = {
  pagination: ConnectionArgs;
};

export type UserUploadedVideosArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Float"]>;
  last?: InputMaybe<Scalars["Float"]>;
};

export type UserWeeklyStatsArgs = {
  date?: InputMaybe<Scalars["String"]>;
};

export type UserYearlyStatsArgs = {
  input?: InputMaybe<UserYearlyStatsInput>;
};

export type UserAchievement = {
  __typename?: "UserAchievement";
  earnedBadges: Array<UserBadge>;
  newBadges: Array<UserBadge>;
};

export type UserAcknowledgeContentInput = {
  module: ContentModule;
  /** The slug identifying the content e.g. terms-and-conditions */
  slug: Scalars["String"];
};

export type UserAuthDeleteInput = {
  uid: Scalars["String"];
};

export type UserAuthUpdateInput = {
  authCode: Scalars["String"];
};

export type UserBadge = {
  __typename?: "UserBadge";
  badge: Badge;
  earnedAt: Scalars["DateTime"];
  earnedById?: Maybe<Scalars["String"]>;
  earnedByType?: Maybe<EarnedByType>;
  id: Scalars["ID"];
  user: User;
};

export type UserBirthDateInput = {
  birthDate: Scalars["DateTime"];
};

export type UserBlock = {
  __typename?: "UserBlock";
  blocked: User;
  blocker: User;
  createdAt: Scalars["DateTime"];
  id: Scalars["ID"];
  reason?: Maybe<ActivityReportReason>;
};

export type UserBlockCreateInput = {
  activityId?: InputMaybe<Scalars["String"]>;
  activityType?: InputMaybe<ActivityType>;
  blockedUserId: Scalars["ID"];
  reason?: InputMaybe<ActivityReportReason>;
};

export type UserBlockRemoveInput = {
  blockedUserId: Scalars["ID"];
};

export type UserCheckUsernameInput = {
  username: Scalars["String"];
};

export type UserClassProgress = {
  __typename?: "UserClassProgress";
  completed: Scalars["Boolean"];
  /** PK */
  id: Scalars["ID"];
  percent: Scalars["Float"];
  time: TimeV2;
};

export type UserConnection = {
  __typename?: "UserConnection";
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type UserCreateInput = {
  email: Scalars["String"];
  uid: Scalars["String"];
};

export type UserCreateReferralInviteInput = {
  advocateId: Scalars["String"];
};

export type UserEdge = {
  __typename?: "UserEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: User;
};

export type UserFilterInput = {
  hasCommunityAccess?: InputMaybe<Scalars["Boolean"]>;
  role?: InputMaybe<Scalars["String"]>;
};

export type UserGenerateUsernameInput = {
  name: Scalars["String"];
};

export type UserMeInput = {
  refreshEstimate?: InputMaybe<Scalars["Boolean"]>;
};

export type UserNameInput = {
  name: Scalars["String"];
};

export type UserNotificationPreferenceUpdateInput = {
  allowAll?: InputMaybe<Scalars["Boolean"]>;
  enabled: Scalars["Boolean"];
  /** Currently same value as source */
  id: Scalars["ID"];
  source: NotificationSourcePreference;
};

export type UserPreferenceOption = {
  __typename?: "UserPreferenceOption";
  description: Scalars["String"];
  displayIndex: Scalars["Int"];
  label: Scalars["String"];
  previewUrl: Scalars["String"];
  slug: Scalars["String"];
};

export enum UserPreferenceType {
  AccountType = "account_type",
  Age = "age",
  DanceEnergy = "dance_energy",
  DanceGoalsCommunity = "dance_goals_community",
  DanceGoalsLearnAndPractice = "dance_goals_learn_and_practice",
  DanceGoalsPersonal = "dance_goals_personal",
  DanceGoalsProfessional = "dance_goals_professional",
  DanceHabit = "dance_habit",
  DanceLocation = "dance_location",
  DaysOfWeek = "days_of_week",
  FamilyGoal = "family_goal",
  HdyhauSurveyResponse = "hdyhau_survey_response",
  Level = "level",
  LevelV2 = "levelV2",
  NumOfDays = "num_of_days",
  Reason = "reason",
}

/** Represents a user's public profile information */
export type UserProfile = {
  __typename?: "UserProfile";
  /** List of badges earned by the user */
  badges?: Maybe<Array<UserBadge>>;
  /** User's self-written biography or description */
  bio?: Maybe<Scalars["String"]>;
  /** User's birth date */
  birthDate?: Maybe<Scalars["DateTime"]>;
  /** Unique identifier for the user profile */
  id: Scalars["ID"];
  /** Slug of the user's instructor profile */
  instructorSlug?: Maybe<Scalars["String"]>;
  /** True if the requesting user has blocked the profile owner. When either direction of a block exists, video/post lists are returned as empty to the requester. */
  isBlockedByMe: Scalars["Boolean"];
  /** List of social media or other relevant links */
  links?: Maybe<Array<UserProfileLink>>;
  /** User's name */
  name?: Maybe<Scalars["String"]>;
  /** URL to the user's profile photo */
  photoURL?: Maybe<Scalars["String"]>;
  /** Firebase user ID associated with this profile */
  uid?: Maybe<Scalars["String"]>;
  /** User's chosen display name */
  username?: Maybe<Scalars["String"]>;
};

export type UserProfileInput = {
  username?: InputMaybe<Scalars["String"]>;
  videoPagination?: InputMaybe<ConnectionArgs>;
};

/** Represents a link in a user's profile */
export type UserProfileLink = {
  __typename?: "UserProfileLink";
  /** Title or label for the link */
  title?: Maybe<Scalars["String"]>;
  /** URL of the link */
  url: Scalars["String"];
};

export type UserProfileLinkInput = {
  title?: InputMaybe<Scalars["String"]>;
  url: Scalars["String"];
};

export type UserProfileUpdateInput = {
  bio?: InputMaybe<Scalars["String"]>;
  birthDate?: InputMaybe<Scalars["DateTime"]>;
  links?: InputMaybe<Array<UserProfileLinkInput>>;
  name?: InputMaybe<Scalars["String"]>;
  uid: Scalars["String"];
};

export type UserProfileWithVideos = {
  __typename?: "UserProfileWithVideos";
  /** List of badges earned by the user */
  badges?: Maybe<Array<UserBadge>>;
  /** User's self-written biography or description */
  bio?: Maybe<Scalars["String"]>;
  /** User's birth date */
  birthDate?: Maybe<Scalars["DateTime"]>;
  /** Unique identifier for the user profile */
  id: Scalars["ID"];
  /** Slug of the user's instructor profile */
  instructorSlug?: Maybe<Scalars["String"]>;
  /** True if the requesting user has blocked the profile owner. When either direction of a block exists, video/post lists are returned as empty to the requester. */
  isBlockedByMe: Scalars["Boolean"];
  isMe: Scalars["Boolean"];
  /** List of social media or other relevant links */
  links?: Maybe<Array<UserProfileLink>>;
  /** User's name */
  name?: Maybe<Scalars["String"]>;
  /** URL to the user's profile photo */
  photoURL?: Maybe<Scalars["String"]>;
  totalLikesCount: Scalars["Float"];
  /** Firebase user ID associated with this profile */
  uid?: Maybe<Scalars["String"]>;
  /** User's chosen display name */
  username?: Maybe<Scalars["String"]>;
  videoUploads: VideoUploadConnection;
};

export type UserProgress = {
  __typename?: "UserProgress";
  acknowledgedContent?: Maybe<Scalars["JSON"]>;
  /** @deprecated Use classes_completed_count */
  classes_completed: Scalars["Int"];
  classes_completed_count: Scalars["Int"];
  id: Scalars["ID"];
  topStreak: Scalars["Int"];
  total_time_spent: Scalars["Int"];
};

export type UserProgressChallenge = {
  __typename?: "UserProgressChallenge";
  achievementId: Scalars["String"];
  currentBadge?: Maybe<Badge>;
  currentBadgeProgress: Scalars["Float"];
  nextBadge?: Maybe<Badge>;
  triggerType: AchievementTriggerType;
};

export type UserRandomizePersonalizedPlaylistInput = {
  uid: Scalars["String"];
};

/** Type of the user reaction */
export enum UserReactionType {
  DoNotUse = "do_not_use",
  Like = "like",
}

export type UserSearchFilterInput = {
  text?: InputMaybe<Scalars["String"]>;
};

export type UserSessionInput = {
  idToken: Scalars["String"];
};

export type UserSetParentalControlsInput = {
  currentPin?: InputMaybe<Scalars["String"]>;
  isEnabled: Scalars["Boolean"];
  newPin?: InputMaybe<Scalars["String"]>;
};

export type UserSetProfilePhoto = {
  photoFile: Scalars["Upload"];
};

export type UserSubscription = {
  __typename?: "UserSubscription";
  cancelationTime?: Maybe<Scalars["Float"]>;
  currentTermEnd?: Maybe<Scalars["Float"]>;
  id: Scalars["String"];
  invoiceDue?: Maybe<Invoice>;
  invoiceEstimate?: Maybe<SubscriptionInvoiceEstimate>;
  isActive: Scalars["Boolean"];
  isCancelable: Scalars["Boolean"];
  isPastDue: Scalars["Boolean"];
  isPauseScheduled: Scalars["Boolean"];
  isReactivatable: Scalars["Boolean"];
  nextBillingAt?: Maybe<Scalars["Float"]>;
  pauseTime?: Maybe<Scalars["Float"]>;
  plan: Plan;
  provider: ProviderInfo;
  resumeTime?: Maybe<Scalars["Float"]>;
  status: SubscriptionStatus;
  trialEndTime?: Maybe<Scalars["Float"]>;
  user: User;
};

export type UserUpdateInput = {
  hasCommunityAccess?: InputMaybe<Scalars["Boolean"]>;
  roles?: InputMaybe<Array<Scalars["String"]>>;
  userId: Scalars["String"];
};

export type UserUpdatePaymentSourceInput = {
  gateway: GatewayInput;
  type: PaymentMethodType;
};

export type UserUpdateUsernameInput = {
  username: Scalars["String"];
};

export type UserUsername = {
  __typename?: "UserUsername";
  exists?: Maybe<Scalars["Boolean"]>;
  username?: Maybe<Scalars["String"]>;
};

export type UserValidatePinInput = {
  pin: Scalars["String"];
};

export type UserWeeklyStats = {
  __typename?: "UserWeeklyStats";
  classesTakenPerDay: Array<ClassesTakenPerDay>;
  secondsSpentPerDay: Array<SecondsSpentPerDay>;
  totalClassesTaken: Scalars["Int"];
  totalSecondsSpent: Scalars["Int"];
};

export type UserYearlyStats = {
  __typename?: "UserYearlyStats";
  topCategoryStyles: Array<ClassCategory>;
  topInstructors: Array<ClassInstructor>;
  totalSecondsSpent: Scalars["Int"];
};

export type UserYearlyStatsInput = {
  limit: Scalars["Float"];
  year?: InputMaybe<Scalars["Float"]>;
};

export type VersionReviewConfig = {
  __typename?: "VersionReviewConfig";
  isInReview: Scalars["Boolean"];
  versionNumber: Scalars["String"];
};

/** The user's video approval status */
export enum VideoApprovalStatus {
  Approved = "approved",
  None = "none",
  Rejected = "rejected",
}

export type VideoCuepoint = {
  __typename?: "VideoCuepoint";
  duration_in_seconds: Scalars["Int"];
  name: Scalars["String"];
  time: Scalars["String"];
};

/** The user's video upload status */
export enum VideoEncodingStatus {
  Available = "available",
  Error = "error",
  Requested = "requested",
  Uploaded = "uploaded",
}

export type VideoMetadata = {
  __typename?: "VideoMetadata";
  hls_sources?: Maybe<HlsSources>;
  sections?: Maybe<Array<Maybe<VideoSection>>>;
};

export type VideoPlaybackResponse = {
  __typename?: "VideoPlaybackResponse";
  backUrl?: Maybe<Scalars["String"]>;
  default360LowUrl: Scalars["String"];
  default360Url: Scalars["String"];
  default540Url: Scalars["String"];
  default720Url: Scalars["String"];
  default1080Url: Scalars["String"];
  defaultUrl: Scalars["String"];
  /** @deprecated DRM support ending. This field will be removed. */
  fairplayCertificateUrl?: Maybe<Scalars["String"]>;
  frontUrl?: Maybe<Scalars["String"]>;
};

export type VideoSection = {
  __typename?: "VideoSection";
  cuepoints?: Maybe<Array<Maybe<VideoCuepoint>>>;
  name: Scalars["String"];
};

/** The type of video */
export enum VideoType {
  Category = "category",
  Class = "class",
  UserChallenge = "user_challenge",
}

export type VideoUpload = {
  __typename?: "VideoUpload";
  approvalStatus: VideoApprovalStatus;
  challenge?: Maybe<Challenge>;
  /** A paginated list of all approved comments on this video. */
  comments?: Maybe<ActivityCommentConnection>;
  createdAt: Scalars["DateTime"];
  description?: Maybe<Scalars["String"]>;
  durationInMs?: Maybe<Scalars["String"]>;
  encodingStatus: VideoEncodingStatus;
  error?: Maybe<Scalars["String"]>;
  /** The number of times the video has been flagged/reported. Requires the admin role to use. */
  flaggedCount: Scalars["Float"];
  id: Scalars["ID"];
  /** True if the video was created by the requesting user. */
  isAuthoredByMe: Scalars["Boolean"];
  isUserDeleted: Scalars["Boolean"];
  isUserSubmitted: Scalars["Boolean"];
  mediaConvertJobIds?: Maybe<Array<Scalars["String"]>>;
  /** The HLS url for the video. */
  playbackUrl?: Maybe<Scalars["String"]>;
  /** The number of reactions to this video by type. */
  reactions: Array<ActivityReactionsCount>;
  /** True if the user has flagged/reported this video at some point */
  reportedByMe: Scalars["Boolean"];
  stepFunctionArn?: Maybe<Scalars["String"]>;
  studioClass?: Maybe<StudioClass>;
  /** The full thumbnail url for the video (without query params). */
  thumbnailUrl?: Maybe<Scalars["String"]>;
  type: VideoType;
  updatedAt: Scalars["DateTime"];
  uploadedAt?: Maybe<Scalars["DateTime"]>;
  /** The profile of the user that uploaded the video. */
  uploadedBy: UserProfile;
  /** The associated user reactions to this video. */
  userReactions?: Maybe<Array<UserReactionType>>;
};

export type VideoUploadCommentsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Float"]>;
  last?: InputMaybe<Scalars["Float"]>;
};

export type VideoUploadAdminUpdateInput = {
  approvalStatus: VideoApprovalStatus;
  videoId: Scalars["String"];
};

export type VideoUploadByIdInput = {
  id: Scalars["String"];
};

export type VideoUploadCompleteInput = {
  parts: Array<MultipartUploadInput>;
  uploadId: Scalars["String"];
  videoId: Scalars["String"];
};

export type VideoUploadConnection = {
  __typename?: "VideoUploadConnection";
  edges: Array<VideoUploadEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type VideoUploadCreateInput = {
  challengeId?: InputMaybe<Scalars["String"]>;
  classNumber?: InputMaybe<Scalars["Float"]>;
  parts: Scalars["Float"];
};

export type VideoUploadCreateResponse = {
  __typename?: "VideoUploadCreateResponse";
  id: Scalars["ID"];
  s3PartsUrls: Array<UploadPart>;
  totalParts?: Maybe<Scalars["Int"]>;
  uploadId?: Maybe<Scalars["String"]>;
};

export type VideoUploadEdge = {
  __typename?: "VideoUploadEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: VideoUpload;
};

export type VideoUploadSubmitInput = {
  classNumber?: InputMaybe<Scalars["Float"]>;
  description?: InputMaybe<Scalars["String"]>;
  platform?: InputMaybe<Platform>;
  videoId: Scalars["String"];
};

export type VideoUploadUpdateInput = {
  description: Scalars["String"];
  videoId: Scalars["String"];
};

export type VideoUploadsFilterInput = {
  approvalStatus?: InputMaybe<VideoApprovalStatus>;
  challengeId?: InputMaybe<Scalars["String"]>;
  encodingStatus?: InputMaybe<VideoEncodingStatus>;
  id?: InputMaybe<Scalars["String"]>;
  isUserDeleted?: InputMaybe<Scalars["Boolean"]>;
  isUserSubmitted?: InputMaybe<Scalars["Boolean"]>;
  updatedAfter?: InputMaybe<Scalars["DateTime"]>;
  updatedBefore?: InputMaybe<Scalars["DateTime"]>;
  userId?: InputMaybe<Scalars["String"]>;
};

export type VideoUploadsPublishedFilterInput = {
  challengeId?: InputMaybe<Scalars["String"]>;
  classNum?: InputMaybe<Scalars["String"]>;
};

export type VideoUrls = {
  __typename?: "VideoUrls";
  video_360p: Scalars["String"];
  video_540p: Scalars["String"];
  video_720p: Scalars["String"];
  video_1080p: Scalars["String"];
  video_auto: Scalars["String"];
  video_cast: Scalars["String"];
};

export type WeeklyStreakGoalInput = {
  streakGoal: Scalars["Int"];
};

export type WeeklyStreakGoalOutput = {
  __typename?: "WeeklyStreakGoalOutput";
  streakGoal: Scalars["Int"];
};

export type GetRecommendedClassesInput = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

export type GetStreakProgressInput = {
  endDate?: InputMaybe<Scalars["String"]>;
  startDate?: InputMaybe<Scalars["String"]>;
};
